<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title v-if="readonly" sliding>{{ tituloDetalle }}</f7-nav-title>
      <f7-nav-title v-else-if="id" sliding>Editar clasificación</f7-nav-title>
      <f7-nav-title v-else sliding>Nueva clasificación</f7-nav-title>
      <f7-nav-right>
        <template v-if="readonly">
          <f7-button color="blue" @click="readonly=false">{{$t('common.editar')}}</f7-button>
          <div class="menu-item menu-item-dropdown bg-color-primary">
            <div class="menu-item-content"><i class="f7-icons">ellipsis_vertical</i></div>
            <div class="menu-dropdown menu-dropdown-right bg-color-primary">
              <div class="menu-dropdown-content bg-color-primary text-align-right">
                <div class="menu-dropdown-item menu-close pointer" @click="irADiscriminantes">Ver discriminantes</div>
                <div class="menu-dropdown-item menu-close pointer" @click="recalcularDiscriminantes">Recalcular con IA</div>
                <div class="menu-dropdown-item menu-close pointer" @click="reclasificarAfectados">Reclasificar items del tipo</div>
                <div class="menu-dropdown-divider"></div>
                <div class="menu-dropdown-item menu-close pointer text-color-red" @click="deleteItem">{{$t('common.eliminar')}}</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <f7-button
            v-if="id"
            color="gray"
            class="display-flex margin-right-half"
            @click="cancelarEdicion"
          >Cancelar</f7-button>
          <f7-button
            fill
            icon-f7="floppy_disk"
            text="Guardar"
            class="display-flex"
            @click="guardarTodo"
          ></f7-button>
        </template>
      </f7-nav-right>
    </f7-navbar>

    <r-form
      ref="rform"
      v-slot="{rform}"
      :itemId="id"
      :beforeSave="beforeSave"
      @save="onSave"
      @loadItem="onLoadItem"
      :readonly="readonly"
      :dbAdapter="ItemClasificacion"
      :defaultData="defaultData"
    >
      <!-- CABECERA -->
      <f7-card class="padding-vertical-half padding-right">
        <f7-card-header><strong>Cabecera</strong></f7-card-header>
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="50" medium="33" small="100">
              <r-input
                outline
                class="col-100"
                floating-label
                label="Código (tipo)"
                :form="rform"
                type="select"
                name="codigo"
                @change="onCodigoSelectChange(rform)"
              >
                <option value=""></option>
                <option v-for="c in codigosDisponibles" :key="c.codigo" :value="c.codigo">{{ c.codigo }}{{ c.denominacion ? ' — ' + c.denominacion : '' }}</option>
                <option v-if="rform.formData.codigo && !codigosDisponibles.some(c => c.codigo === rform.formData.codigo)" :value="rform.formData.codigo">{{ rform.formData.codigo }}</option>
                <option v-if="!readonly" value="__NUEVO__">➕ Nuevo tipo…</option>
              </r-input>
            </f7-col>
            <f7-col width="50" medium="33" small="100">
              <r-input
                outline
                class="col-100 naturaleza-input"
                floating-label
                label="Naturaleza"
                :form="rform"
                type="select"
                name="naturaleza"
                :style="{'--naturaleza-bg': naturalezaColor(rform.formData.naturaleza)}"
              >
                <option value=""></option>
                <option v-for="n in naturalezas" :key="n.valor" :value="n.valor" :style="{backgroundColor: n.bgColor || 'transparent', color: n.color || 'inherit'}">{{ n.valor }} — {{ n.label }}</option>
              </r-input>
            </f7-col>
            <f7-col width="100" medium="33" small="100">
              <r-input outline class="col-100" floating-label label="Estado tipificación" :form="rform" type="select" name="estadoTipificacion">
                <option value=""></option>
                <option value="TIPIFICADO">Tipificado</option>
                <option value="EN_CURSO">En curso</option>
                <option value="PENDIENTE">Pendiente</option>
                <option value="FUSIONADA">Fusionada</option>
              </r-input>
            </f7-col>
            <f7-col width="100" medium="100" small="100">
              <r-input outline class="col-100" floating-label label="Denominación" :form="rform" type="text" name="denominacion"></r-input>
            </f7-col>
            <f7-col width="100" medium="50" small="100">
              <r-input outline class="col-100" floating-label label="Reglamento" :form="rform" type="text" name="reglamento"></r-input>
            </f7-col>
            <f7-col width="100" medium="50" small="100">
              <r-input outline class="col-100" floating-label label="ITC / norma técnica" :form="rform" type="text" name="itc"></r-input>
            </f7-col>
          </f7-row>
        </f7-card-content>
      </f7-card>

      <!-- SUBTIPOS (path jerárquico) -->
      <f7-card class="padding-vertical-half padding-right">
        <f7-card-header>
          <strong>Subtipos (path jerárquico)</strong>
          <f7-link v-if="!rform.readonly" class="margin-left" icon-f7="plus_circle" @click="addSubtipo(rform)">Añadir</f7-link>
        </f7-card-header>
        <f7-card-content>
          <div v-if="!(rform.formData.subtipos && rform.formData.subtipos.length)" class="text-color-gray padding-left">Sin subtipos.</div>
          <f7-row v-else no-gap class="list list-form no-hairlines">
            <f7-col v-for="(s, i) in rform.formData.subtipos" :key="'subt-'+i" width="100" medium="25" small="100" style="position:relative;">
              <r-input
                outline
                class="col-100"
                floating-label
                :label="i === 0 ? 'Subtipo 1 (principal)' : 'Subtipo ' + (i+1)"
                :form="rform"
                type="text"
                :name="'subtipos.' + i"
              ></r-input>
              <f7-link
                v-if="!rform.readonly"
                icon-f7="trash"
                color="red"
                @click="removeSubtipo(rform, i)"
                style="position:absolute;right:8px;top:50%;transform:translateY(-50%);"
              ></f7-link>
            </f7-col>
            <!-- Rellenamos huecos hasta el siguiente múltiplo de 4 para que la última fila quede alineada. -->
            <div v-for="i in subtiposRelleno(rform.formData.subtipos.length)" :key="'subt-fill-'+i" class="col-100 medium-25 small-100"></div>
          </f7-row>
        </f7-card-content>
      </f7-card>

      <!-- MATERIAS ERP VINCULADAS -->
      <f7-card>
        <f7-card-header><strong>Materias ERP vinculadas</strong></f7-card-header>
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <r-autocomplete-m2m
              ref="materiasAutocomplete"
              class="col-100"
              :dbAdapter="Materia"
              :form="rform"
              name="materias"
              floating-label
              label="Materias ERP"
              labelProp="nombre"
              prefixProp="codigo"
              idProp="codigo"
              idFieldDetail="id"
              :chipsView="true"
              :disabled="rform.readonly"
            ></r-autocomplete-m2m>
          </f7-row>
        </f7-card-content>
      </f7-card>

      <!-- FORMATOS ABSTRAÍDOS (de los que se construyó esta tipología) -->
      <f7-card>
        <f7-card-header>
          <strong>Formatos abstraídos</strong>
          <span class="text-color-gray margin-left" style="font-size:12px;">
            Formatos cubiertos por esta clasificación (no se vuelven a listar en la revisión).
          </span>
        </f7-card-header>
        <f7-card-content>
          <!-- Sin filtro por `inspeccionable`: la revisión de formatos vincula a propósito los
               históricos (no inspeccionable significa "ya no se crean inspecciones con él", no
               "nunca las hubo", y sus expedientes antiguos siguen necesitando clasificación).
               Con el filtro puesto no salían como chip —el componente pinta el valor cruzándolo
               con los items cargados—, así que no se podían quitar y se perdían al tocar el resto. -->
          <f7-row no-gap class="list list-form no-hairlines">
            <r-autocomplete-m2m
              ref="formatosAutocomplete"
              class="col-100"
              :dbAdapter="Formato"
              :form="rform"
              name="formatosUsados"
              floating-label
              label="Formatos"
              labelProp="nombre"
              prefixProp="codigo"
              searchProp="nombre"
              idProp="codigo"
              idFieldDetail="id"
              :chipsView="true"
              :disabled="rform.readonly"
            ></r-autocomplete-m2m>
          </f7-row>
          <div v-if="!rform.readonly" class="formatos-ia-bar">
            <a class="link ia-text" @click="sugerirCaracteristicasDesdeFormatos(rform)">
              <i class="f7-icons">wand_stars</i>
              <span>Sugerir características desde formatos</span>
            </a>
            <span class="text-color-gray" style="font-size:11px;">
              Agrupa las características equivalentes de los formatos seleccionados; eliges el nombre canónico y el resto quedan como alias.
            </span>
          </div>
        </f7-card-content>
      </f7-card>

      <!-- DISCRIMINANTES (condiciones sobre el VALOR que distinguen este subtipo de sus hermanos) -->
      <f7-card class="padding-vertical-half padding-right" id="card-discriminantes">
        <f7-card-header>
          <strong>Discriminantes de subtipo</strong>
          <span class="text-color-gray margin-left" style="font-size:12px;">
            Condiciones sobre el VALOR que distinguen este subtipo de sus hermanos. Se evalúan en AND.
          </span>
          <f7-button v-if="!rform.readonly" small fill class="ia-btn margin-left"
                     @click="recalcularDiscriminantes" :disabled="discCargando">
            <i class="f7-icons" style="font-size:14px;">wand_stars</i> Recalcular con IA
          </f7-button>
          <f7-button v-if="discCargando" small round color="red" class="margin-left" @click="cancelarDiscriminantes">Cancelar</f7-button>
        </f7-card-header>
        <f7-card-content>
          <div v-if="!(rform.formData.subtipos && rform.formData.subtipos.length)" class="text-color-gray padding-left">
            Esta clasificación no tiene subtipos: no hay hermanos de los que distinguirla.
          </div>
          <template v-else>
            <r-ia-pensando v-if="discCargando" :narracion="discNarracion" latin-default="Thinking"
                           texto-default="Analizando las opciones declaradas en los formatos…" />

            <!-- Reclasificación en marcha: contador n/total + cuántos han cambiado ya -->
            <div v-if="reclasEnCurso" class="disc-reclas-banner">
              <i class="f7-icons" style="font-size:16px;">arrow_2_circlepath</i>
              <span style="font-weight:600;">{{ (reclasNarracion && reclasNarracion.latin) || 'Reclassifying' }}</span>
              <span class="text-color-gray">{{ (reclasNarracion && reclasNarracion.texto) || 'Reclasificando items…' }}</span>
              <span v-if="reclasNarracion && reclasNarracion.total" class="disc-reclas-cont">
                {{ reclasNarracion.hechos }} / {{ reclasNarracion.total }}
              </span>
              <span v-if="reclasCambiados" class="badge color-green" style="font-size:10px;">
                {{ reclasCambiados }} cambiado(s)
              </span>
              <f7-button small round color="red" style="margin-left:auto;" @click="cancelarReclasificacion">Cancelar</f7-button>
            </div>

            <div v-if="discPropuestaPendiente" class="disc-pendiente">
              Propuesta de la IA cargada. Revísala y pulsa <b>Guardar</b> arriba para aplicarla.
            </div>

            <div v-if="!(rform.formData.condicionesDiscriminacion && rform.formData.condicionesDiscriminacion.length)"
                 class="text-color-gray padding-left" style="font-size:12px;">
              Sin condiciones: este subtipo no se distingue por valor (se elegirá por profundidad y cobertura).
            </div>

            <div v-for="(c, ci) in (rform.formData.condicionesDiscriminacion || [])" :key="'dcond-'+ci" class="disc-cond">
              <div class="disc-cond-linea">
                <span class="disc-si">Si el campo</span>
                <div class="disc-carac-wrap">
                  <select v-model="c.caracteristica" class="disc-select" :disabled="rform.readonly">
                    <option v-for="ca in discCatalogo" :key="'dcc-'+ci+'-'+ca.nombre" :value="ca.nombre">
                      {{ ca.label || ca.nombre }}
                    </option>
                    <option v-if="c.caracteristica && !discCatalogo.some(x => x.nombre === c.caracteristica)"
                            :value="c.caracteristica">{{ c.caracteristica }} (no declarada)</option>
                  </select>
                  <code class="disc-nombre-tec">{{ c.caracteristica }}<span class="disc-opc-count">· {{ opcionesDeclaradas(c.caracteristica).length }} opc.</span></code>
                </div>
                <select v-model="c.operador" class="disc-select" :disabled="rform.readonly" :title="ayudaOperador(c.operador)">
                  <option v-for="op in OPERADORES_DISC" :key="'dop-'+ci+'-'+op" :value="op">{{ etiquetaOperador(op) }}</option>
                </select>

                <template v-if="esOperadorNumerico(c.operador)">
                  <input class="disc-input" type="number" v-model.number="c.valorNumerico" placeholder="valor" :disabled="rform.readonly" />
                  <span v-if="c.operador === 'ENTRE'" class="disc-si">y</span>
                  <input v-if="c.operador === 'ENTRE'" class="disc-input" type="number" v-model.number="c.valorNumericoHasta"
                         placeholder="valor" :disabled="rform.readonly" />
                  <span v-if="c.unidad" class="text-color-gray" style="font-size:11px;">{{ c.unidad }}</span>
                </template>
                <span v-else-if="c.operador === 'EXISTE'" class="text-color-gray" style="font-size:11px;">
                  (basta con que el campo esté relleno)
                </span>

                <f7-link v-if="!rform.readonly" icon-f7="trash" color="red" style="margin-left:auto;"
                         @click="rform.formData.condicionesDiscriminacion.splice(ci, 1)"></f7-link>
              </div>

              <div v-if="!esOperadorNumerico(c.operador) && c.operador !== 'EXISTE'" class="disc-valores">
                <span class="disc-valores-lbl">contiene alguno de:</span>
                <span v-for="(v, vi) in (c.valores || [])" :key="'dv-'+ci+'-'+vi" class="chip-valor" :title="v"
                      @click="!rform.readonly && c.valores.splice(vi, 1)">
                  {{ v }} <i v-if="!rform.readonly" class="f7-icons chip-x">xmark_circle_fill</i>
                </span>
                <span v-if="!(c.valores || []).length" class="disc-falta">⚠ falta el valor</span>
                <select v-if="!rform.readonly && opcionesParaAnadir(c).length" class="disc-select"
                        @change="anadirValorSelect(c, $event)">
                  <option value="">+ añadir valor declarado…</option>
                  <option v-for="(op, oi) in opcionesParaAnadir(c)" :key="'dao-'+ci+'-'+oi" :value="op">{{ op }}</option>
                </select>
                <input v-else-if="!rform.readonly" class="disc-input disc-input-libre" placeholder="+ escribe un valor y Enter"
                       @keyup.enter="anadirValorTexto(c, $event)" />
              </div>

              <div v-if="c.justificacion" class="disc-just">{{ c.justificacion }}</div>
            </div>

            <f7-button v-if="!rform.readonly" small @click="anadirCondicion(rform)" style="margin-top:6px;">
              + Añadir condición
            </f7-button>

            <!-- Empates en los que participa esta clasificación: delatan condiciones accesorias -->
            <div v-if="discEmpates.length" class="disc-empates-zona">
              <div class="text-color-gray" style="font-size:11px;font-weight:600;">
                Empates al clasificar en los que participa este subtipo:
              </div>
              <div v-for="(e, ei) in discEmpates" :key="'demp-'+ei" class="disc-empate">
                <span class="badge color-red" style="font-size:10px;">{{ e.veces }}×</span>
                <span v-for="(d, di) in (e.descripciones || [])" :key="'ded-'+ei+'-'+di"
                      class="badge color-purple" style="font-size:10px;margin-left:3px;">{{ d }}</span>
                <span class="text-color-gray" style="font-size:10px;margin-left:6px;">
                  resuelto por {{ e.resueltoPor }}{{ e.clasificacionElegida ? ' → ' + e.clasificacionElegida : '' }}
                </span>
                <div v-if="e.justificacion" class="disc-just">{{ e.justificacion }}</div>
                <div v-for="(a, ai) in (e.condicionesAccesorias || [])" :key="'dea-'+ei+'-'+ai"
                     style="font-size:10px;color:#b36b00;">condición poco discriminante: {{ a }}</div>
              </div>
            </div>
          </template>
        </f7-card-content>
      </f7-card>

      <!-- GRUPOS DE CARACTERÍSTICAS (resueltos por tipología, edición diferida) -->
      <f7-card class="padding-vertical-half padding-right">
        <f7-card-header>
          <strong>Grupos de características</strong>
          <span class="text-color-gray margin-left" style="font-size:12px;">
            Click en chips para mover características entre niveles. Click en la
            <span class="chip-manual-badge">M</span> para liberar el bloqueo manual y
            que la IA pueda reubicarla.
          </span>
          <span
            v-if="!rform.readonly && hayCambiosCaracteristicas"
            class="margin-left cambios-pendientes-aviso"
            title="Se guardan al pulsar «Guardar» en la cabecera"
          >{{ Object.keys(cambiosCaracteristicas).length }} cambio(s) sin guardar</span>
          <f7-link
            v-if="!rform.readonly && hayCambiosCaracteristicas"
            class="margin-left"
            icon-f7="arrow_uturn_left"
            color="gray"
            @click="cancelarCambiosCaracteristicas"
          >Descartar</f7-link>
        </f7-card-header>
        <f7-card-content>
          <!-- Plantilla de generación del ID canónico de los items de esta tipología -->
          <div class="plantilla-id-row">
            <span class="caract-label">Plantilla de ID del item:</span>
            <input
              v-if="!rform.readonly"
              ref="plantillaInput"
              class="plantilla-id-input"
              placeholder="p. ej. AE-{rae} · ({rae}||{marca_fabricante})||{direccionInspeccion.placeId}"
              :value="plantillaIdEfectiva"
              @change="onPlantillaIdChange($event.target.value)"
            />
            <code v-else class="plantilla-id-valor">{{ plantillaIdEfectiva || '— sin plantilla —' }}</code>
            <!-- Chips de nivel: en qué tipología vive (o vivirá) la plantilla -->
            <span v-if="plantillaIdEfectiva" class="plantilla-chips">
              <span
                v-for="(chip, idx) in chipsPlantilla()"
                :key="'pchip-' + idx"
                class="chip-tipologia"
                :class="{
                  'chip-activo': chip.activo,
                  'chip-clickable': !rform.readonly && (chip.activo || idx === nivelPlantillaEfectivo + 1),
                  'chip-raiz': idx === 0
                }"
                :title="chip.titulo"
                @click="rform.readonly ? null : onChipPlantillaClick(idx)"
              >{{ chip.label }}</span>
            </span>
            <span class="text-color-gray" style="font-size:11px;">
              <template v-if="hayCambioPlantillaPendiente">pendiente de guardar</template>
              <template v-else-if="tipologiaClasificacion.plantillaIdItem">guardada</template>
              <template v-else>sin plantilla — el ID se calcula por sectorial/naturaleza</template>
            </span>
            <span class="text-color-gray" style="font-size:11px; flex-basis:100%;">
              Operadores: <b>||</b> usa la primera alternativa con valor y <b>( )</b> agrupa. Ej: <code>({rae}||{marca_fabricante})||{direccionInspeccion.placeId}</code>
            </span>
            <!-- Constructor: click para añadir/quitar tokens (toggle). Una fila por grupo. -->
            <div v-if="!rform.readonly" class="plantilla-builder">
              <div class="token-grupo-row">
                <span class="token-grupo-label">Especial</span>
                <span
                  class="token-chip token-chip-tipo"
                  :class="{'token-chip-usado': tokenUsadoEnPlantilla('TIPO')}"
                  :title="tokenUsadoEnPlantilla('TIPO') ? 'En uso — click para quitar de la plantilla' : 'Código del tipo (AE, REBT...) — click para añadir'"
                  @click="toggleTokenPlantilla('TIPO')"
                >{TIPO}</span>
              </div>
              <div class="token-grupo-row">
                <span class="token-grupo-label">Dirección de inspección</span>
                <span
                  v-for="t in tokensEmplazamiento"
                  :key="'ptoken-' + t.nombre"
                  class="token-chip token-chip-emplazamiento"
                  :class="{'token-chip-usado': tokenUsadoEnPlantilla(t.nombre)}"
                  :title="t.label + ' (' + t.nombre + ', de la dirección del expediente)' + (tokenUsadoEnPlantilla(t.nombre) ? ' — EN USO, click para quitar' : ' — click para añadir')"
                  @click="toggleTokenPlantilla(t.nombre)"
                >{{ t.label }}</span>
              </div>
              <div
                v-for="(sec, si) in tokensCaractPorGrupo"
                :key="'tsec-' + sec.codigo"
                class="token-grupo-row"
              >
                <span class="token-grupo-label" :style="{ color: tokenPaleta[si % tokenPaleta.length] }">{{ sec.denominacion }}</span>
                <span
                  v-for="t in sec.tokens"
                  :key="'ptoken-' + t.nombre"
                  class="token-chip"
                  :style="estiloChipGrupo(si, tokenUsadoEnPlantilla(t.nombre))"
                  :title="(t.label || t.nombre) + ' — ' + t.nivelTitulo + (tokenUsadoEnPlantilla(t.nombre) ? ' — EN USO, click para quitar' : ' — click para añadir')"
                  @click="toggleTokenPlantilla(t.nombre)"
                >{{ t.nombre }}</span>
              </div>
            </div>
          </div>
          <div v-if="!rform.readonly && id" class="admin-manual-barra">
            <f7-link icon-f7="rectangle_stack_badge_plus" @click="nuevoGrupo">Nuevo grupo</f7-link>
            <f7-link icon-f7="square_grid_2x2" @click="cargarChipsFormato" :class="{ 'text-color-gray': cargandoChips }">
              {{ cargandoChips ? 'Cargando…' : 'Características de los formatos' }}
            </f7-link>
          </div>
          <div v-if="!rform.readonly && formatoChipsGrupos.length" class="formato-chips-barra">
            <div class="formato-chips-cabecera">
              <span class="text-color-gray" style="font-size:11px;">Solo las NO asignadas. Arrastra un chip <b>sobre una característica</b> = añadir como alias; <b>sobre un grupo</b> = añadir como característica nueva.</span>
              <a class="link" style="font-size:11px;" @click="toggleTodosChips">{{ todosChipsColapsados ? 'Desplegar todo' : 'Plegar todo' }}</a>
            </div>
            <div v-for="fg in formatoChipsGrupos" :key="'fcg-'+fg.codigo" class="formato-chips-grupo">
              <div class="formato-chips-grupo-tit" :title="fg.nombre || fg.codigo" @click="toggleChipFormato(fg.codigo)">
                <i class="f7-icons">{{ formatoChipsColapsados[fg.codigo] ? 'chevron_right' : 'chevron_down' }}</i>
                <code>{{ fg.codigo }}</code><span v-if="fg.nombre" class="text-color-gray"> · {{ fg.nombre }}</span>
                <span class="formato-chips-count">{{ fg.caracteristicas.length }}</span>
              </div>
              <div v-show="!formatoChipsColapsados[fg.codigo]" class="formato-chips-grupo-chips">
                <span v-for="(ch, chi) in fg.caracteristicas" :key="'fch-'+fg.codigo+'-'+chi" class="formato-chip"
                      :style="estiloChipGrupo(ch.grupoCodigo)"
                      draggable="true" @dragstart="onDragChipStart(ch, $event)" @dragend="onDragEnd"
                      :title="tituloChip(ch)">{{ ch.nombre }}</span>
              </div>
            </div>
          </div>
          <!-- Mientras se arrastra (característica de un grupo o chip de formato): bloques grandes
               por grupo para soltar fácil. Característica → mover de grupo; chip → añadir nueva. -->
          <div v-if="dragItem && (dragItem.kind === 'car' || dragItem.kind === 'chip')" class="drop-grupos-barra">
            <span class="drop-grupos-hint">
              {{ dragItem.kind === 'chip' ? 'Añade «' + dragItem.nombre + '» como NUEVA a:' : 'Suelta «' + dragItem.nombre + '» en:' }}
            </span>
            <template v-for="g in gruposMostrar">
              <div v-if="g.codigo !== dragItem.grupoCodigo" :key="'drop-' + g.codigo"
                   class="drop-grupo-bloque" @dragover.prevent @drop="onDropEnGrupo(g, $event)">
                <i class="f7-icons">tray_arrow_down</i>
                {{ g.denominacion || g.codigo }}
              </div>
            </template>
          </div>
          <div v-if="cargandoGruposResueltos" class="text-color-gray padding-left">Cargando…</div>
          <div v-else-if="!gruposMostrar.length" class="text-color-gray padding-left">
            Sin grupos definidos en el catálogo de tipologías para esta clasificación.
          </div>
          <div v-else>
            <div v-for="(g, gi) in gruposMostrar" :key="'gres-' + gi" class="grupo-card"
                 :class="{ 'grupo-dropzone': dragItem && (dragItem.kind === 'car' || dragItem.kind === 'chip') }"
                 @dragover.prevent @drop="onDropEnGrupo(g, $event)">
              <div class="grupo-header">
                <strong>{{ g.denominacion || g.codigo }}</strong>
                <span class="text-color-gray" style="font-size:11px; margin-left:8px;">{{ g.codigo }}</span>
                <span v-if="g.obligatorio" class="grupo-obligatorio-badge">obligatorio</span>
                <span v-if="!rform.readonly" class="grupo-acciones">
                  <f7-link icon-f7="pencil" color="blue" @click="renombrarGrupo(g)" title="Renombrar grupo"></f7-link>
                  <f7-link v-if="!g.obligatorio" icon-f7="trash" color="red" @click="eliminarGrupo(g)"
                           :title="(caracteristicasEfectivas(g) || []).length ? 'Vacía el grupo antes de borrarlo' : 'Borrar grupo'"></f7-link>
                </span>
              </div>
              <div class="grupo-body">
                <div v-if="!(caracteristicasEfectivas(g) || []).length" class="text-color-gray padding-left">Sin características.</div>
                <table v-else class="caracteristicas-resueltas">
                  <thead>
                    <tr>
                      <th v-if="!rform.readonly" style="width:22px;"></th>
                      <th>Nombre</th>
                      <th>Etiqueta</th>
                      <th>Tipo</th>
                      <th>Aliases</th>
                      <th>Tipología</th>
                      <th v-if="!rform.readonly" style="width:30px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(c, ci) in caracteristicasEfectivas(g)" :key="'gres-' + gi + '-' + ci"
                        :class="{
                          'caracteristica-modificada': estaCaracteristicaCambiada(g.codigo, c.nombre),
                          'caracteristica-eliminada': estaCaracteristicaMarcadaParaBorrar(g.codigo, c.nombre),
                          'caracteristica-nueva': estaCaracteristicaNueva(g.codigo, c.nombre),
                          'caracteristica-droptarget': dragItem && dragItem.kind === 'chip'
                        }"
                        @dragover.prevent @drop.stop="onDropEnCaracteristica(g, c, $event)">
                      <td v-if="!rform.readonly" class="drag-handle-cell">
                        <span class="drag-grip" draggable="true" @dragstart="onDragCarStart(g, c, $event)" @dragend="onDragEnd"
                              title="Arrastra para reordenar o mover de grupo">⠿</span>
                      </td>
                      <td>
                        <code>{{ c.nombre }}</code>
                        <span v-if="c._nombreNuevo" class="rename-pending" :title="'Se renombrará a ' + c._nombreNuevo + ' al guardar (el actual pasa a alias)'">→ <code>{{ c._nombreNuevo }}</code></span>
                        <span v-if="formatosDeCaracteristica(c).length" class="caract-formatos-origen" title="Formatos de los que procede esta característica">
                          <i class="f7-icons">doc_text</i>
                          <span v-for="code in formatosDeCaracteristica(c)" :key="'fo-'+code" class="formato-origen-chip">{{ code }}</span>
                        </span>
                      </td>
                      <td>{{ c.label || '' }}</td>
                      <td><span class="text-color-gray">{{ c.tipo || '' }}</span></td>
                      <td><span class="text-color-gray">{{ (c.aliases || []).join(', ') }}</span></td>
                      <td>
                        <span
                          v-for="(chip, idx) in chipsDeCaracteristica(g.codigo, c)"
                          :key="'chip-' + gi + '-' + ci + '-' + idx"
                          class="chip-tipologia"
                          :class="{
                            'chip-activo': chip.activo,
                            'chip-clickable': !rform.readonly && (chip.activo || idx === profundidadEfectiva(g.codigo, c) + 1),
                            'chip-raiz': idx === 0
                          }"
                          @click="rform.readonly ? null : onChipClick(g, c, idx)"
                          :title="chip.titulo"
                        >
                          {{ chip.label }}
                          <span
                            v-if="chip.activo && chip.manual && !rform.readonly"
                            class="chip-manual-badge"
                            @click.stop="onToggleManual(g, c)"
                            title="Bloqueada manualmente — click para liberar y dejar que la IA la reorganice"
                          >M</span>
                        </span>
                      </td>
                      <td v-if="!rform.readonly" style="text-align:right; white-space:nowrap;">
                        <f7-link
                          v-if="!estaCaracteristicaMarcadaParaBorrar(g.codigo, c.nombre)"
                          icon-f7="pencil"
                          color="blue"
                          @click="abrirEdicionCaracteristica(g, c)"
                          title="Editar característica"
                          class="margin-right-half"
                        ></f7-link>
                        <f7-link
                          v-if="!estaCaracteristicaMarcadaParaBorrar(g.codigo, c.nombre)"
                          icon-f7="trash"
                          color="red"
                          @click="onBorrarCaracteristica(g, c)"
                          title="Eliminar de esta tipología"
                        ></f7-link>
                        <f7-link
                          v-else
                          icon-f7="arrow_uturn_left"
                          color="gray"
                          @click="cancelarBorrarCaracteristica(g, c)"
                          title="Cancelar borrado"
                        ></f7-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="!rform.readonly" class="grupo-body-footer">
                  <f7-link icon-f7="plus_circle" @click="abrirAltaCaracteristica(g)">Añadir característica</f7-link>
                </div>
              </div>
            </div>
          </div>
        </f7-card-content>
      </f7-card>

      <!-- GRUPOS LOCALES (override por clasificación) - oculto por ahora -->
      <f7-card v-if="false" class="padding-vertical-half padding-right">
        <f7-card-header>
          <strong>Grupos de características (override local)</strong>
          <f7-link v-if="!rform.readonly" class="margin-left" icon-f7="plus_circle" @click="addGrupo(rform)">Añadir grupo</f7-link>
        </f7-card-header>
        <f7-card-content>
          <div v-if="!(rform.formData.grupos && rform.formData.grupos.length)" class="text-color-gray padding-left">Sin grupos. Pulsa "Añadir grupo".</div>
          <div v-for="(g, gi) in rform.formData.grupos" :key="'grupo-' + gi" class="grupo-card">
            <div class="grupo-header">
              <r-input
                outline
                floating-label
                label="Denominación del grupo"
                :form="rform"
                type="text"
                :name="'grupos.' + gi + '.denominacion'"
                class="grupo-denom"
              ></r-input>
              <r-input
                outline
                floating-label
                label="Código"
                :form="rform"
                type="text"
                :name="'grupos.' + gi + '.codigo'"
                class="grupo-codigo"
                :readonly="!!g.obligatorio"
              ></r-input>
              <r-input
                outline
                floating-label
                label="Orden"
                :form="rform"
                type="number"
                :name="'grupos.' + gi + '.orden'"
                class="grupo-orden"
              ></r-input>
              <span v-if="g.obligatorio" class="grupo-obligatorio-badge">obligatorio</span>
              <f7-link
                v-if="!rform.readonly && !g.obligatorio"
                icon-f7="trash"
                color="red"
                @click="removeGrupo(rform, gi)"
                v-tooltip="'Eliminar grupo'"
              ></f7-link>
            </div>
            <div class="grupo-body">
              <div class="grupo-body-header">
                <span class="text-color-gray">Características</span>
                <f7-link v-if="!rform.readonly" icon-f7="plus_circle" @click="addCaracteristica(rform, gi)">Añadir característica</f7-link>
              </div>
              <div v-if="!(g.caracteristicas && g.caracteristicas.length)" class="text-color-gray padding-left">Sin características.</div>
              <f7-row v-else no-gap class="list list-form no-hairlines">
                <f7-col v-for="(c, ci) in g.caracteristicas" :key="'g'+gi+'-c'+ci" width="100" class="caracteristica-row">
                  <r-input
                    outline
                    floating-label
                    label="Nombre"
                    :form="rform"
                    type="text"
                    :name="'grupos.' + gi + '.caracteristicas.' + ci + '.nombre'"
                  ></r-input>
                  <r-input
                    outline
                    floating-label
                    label="Etiqueta"
                    :form="rform"
                    type="text"
                    :name="'grupos.' + gi + '.caracteristicas.' + ci + '.label'"
                  ></r-input>
                  <r-input
                    outline
                    floating-label
                    label="Tipo"
                    :form="rform"
                    type="select"
                    :name="'grupos.' + gi + '.caracteristicas.' + ci + '.tipo'"
                  >
                    <option value=""></option>
                    <option v-for="t in tiposCaracteristica" :key="t" :value="t">{{ t }}</option>
                  </r-input>
                  <r-input
                    outline
                    floating-label
                    :simple="true"
                    label="Obligatorio"
                    :form="rform"
                    type="check"
                    :name="'grupos.' + gi + '.caracteristicas.' + ci + '.obligatorio'"
                  ></r-input>
                  <r-input
                    outline
                    floating-label
                    label="Alias (separados por coma)"
                    :form="rform"
                    type="text"
                    :name="'grupos.' + gi + '.caracteristicas.' + ci + '.aliasesText'"
                    v-tooltip="'Nombres alternativos del campo para reconocer datos de expedientes antiguos'"
                  ></r-input>
                  <f7-link
                    v-if="!rform.readonly"
                    icon-f7="trash"
                    color="red"
                    @click="removeCaracteristica(rform, gi, ci)"
                    v-tooltip="'Eliminar característica'"
                  ></f7-link>
                </f7-col>
              </f7-row>
            </div>
          </div>
        </f7-card-content>
      </f7-card>

      <!-- OBSERVACIONES -->
      <f7-card class="padding-vertical-half padding-right">
        <f7-card-header><strong>Observaciones</strong></f7-card-header>
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="100">
              <r-input
                outline
                class="col-100 observaciones-input"
                floating-label
                label=""
                :form="rform"
                type="textarea"
                name="observaciones"
                resizable
              ></r-input>
            </f7-col>
          </f7-row>
        </f7-card-content>
      </f7-card>

      <!-- INDICACIONES PARA LA IDENTIFICACIÓN -->
      <f7-card class="padding-vertical-half padding-right">
        <f7-card-header><strong>Indicaciones para la identificación</strong></f7-card-header>
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="100">
              <p class="indicaciones-identificacion-hint">
                Guía para la IA sobre qué hace válido el identificador de este item (p. ej. "el RAE es
                alfanumérico sin caracteres especiales; si no hay provincia, revisar"). Se usa al crear
                un item nuevo para marcarlo como posible identificador erróneo si el valor resuelto no encaja.
              </p>
              <r-input
                outline
                class="col-100 observaciones-input"
                floating-label
                label=""
                :form="rform"
                type="textarea"
                name="indicacionesIdentificacion"
                resizable
              ></r-input>
            </f7-col>
          </f7-row>
        </f7-card-content>
      </f7-card>
    </r-form>

    <!-- Popup: alta rápida de un nuevo tipo de clasificación -->
    <f7-popup
      class="popup-nuevo-tipo"
      v-if="nuevoTipoPopupOpened"
      :opened="true"
      @popup:closed="nuevoTipoPopupOpened = false"
    >
      <f7-page>
        <f7-navbar title="Nuevo tipo de clasificación">
          <f7-nav-right><f7-link popup-close>Cancelar</f7-link></f7-nav-right>
        </f7-navbar>
        <r-form
          ref="rformNuevoTipo"
          v-slot="{rform: rformTipo}"
          :beforeSave="beforeSaveNuevoTipo"
          @save="onNuevoTipoCreado"
          :dbAdapter="ItemTipoClasificacion"
          :defaultData="nuevoTipoDefault"
        >
          <f7-card class="padding-vertical-half padding-right">
            <f7-card-content>
              <f7-row no-gap class="list list-form no-hairlines">
                <f7-col width="50" medium="50" small="100">
                  <r-input outline class="col-100" floating-label label="Código" :form="rformTipo" type="text" name="codigo"></r-input>
                </f7-col>
                <f7-col width="50" medium="50" small="100">
                  <r-input outline class="col-100" floating-label label="Naturaleza por defecto" :form="rformTipo" type="select" name="naturalezaDefault">
                    <option value=""></option>
                    <option v-for="n in naturalezas" :key="n.valor" :value="n.valor" :style="{backgroundColor: n.bgColor || 'transparent', color: n.color || 'inherit'}">{{ n.valor }} — {{ n.label }}</option>
                  </r-input>
                </f7-col>
                <f7-col width="100" medium="100" small="100">
                  <r-input outline class="col-100" floating-label label="Denominación" :form="rformTipo" type="text" name="denominacion"></r-input>
                </f7-col>
                <f7-col width="100" medium="50" small="100">
                  <r-input outline class="col-100" floating-label label="Reglamento por defecto" :form="rformTipo" type="text" name="reglamentoDefault"></r-input>
                </f7-col>
                <f7-col width="100" medium="50" small="100">
                  <r-input outline class="col-100" floating-label label="ITC por defecto" :form="rformTipo" type="text" name="itcDefault"></r-input>
                </f7-col>
                <f7-col width="100" medium="50" small="100">
                  <r-input outline class="col-100" floating-label label="Color asociado" :form="rformTipo" type="select" name="colorBadge">
                    <option v-for="c in colorOptions" :key="c" :value="c" :style="colorOptionStyle(c)">{{ c }}</option>
                  </r-input>
                </f7-col>
              </f7-row>
              <f7-button fill icon-f7="checkmark_alt" text="Crear" class="margin-top" @click="$refs.rformNuevoTipo.saveItem()"></f7-button>
            </f7-card-content>
          </f7-card>
        </r-form>
      </f7-page>
    </f7-popup>

    <!-- Popup: alta o edición de característica del grupo seleccionado -->
    <f7-popup
      class="popup-nueva-caracteristica"
      v-if="nuevaCaractPopupOpened"
      :opened="true"
      @popup:closed="onPopupCaracteristicaClosed"
    >
      <f7-page>
        <f7-navbar :title="(nuevaCaractModo === 'edicion' ? 'Editar característica — ' : 'Nueva característica — ') + (nuevaCaractGrupo && (nuevaCaractGrupo.denominacion || nuevaCaractGrupo.codigo) || '')">
          <f7-nav-right><f7-link popup-close>Cancelar</f7-link></f7-nav-right>
        </f7-navbar>
        <f7-card class="padding-vertical-half padding-right">
          <f7-card-content>
            <f7-row no-gap>
              <f7-col width="100" medium="50" small="100" class="padding-right-half">
                <div class="caract-label">Nombre (clave)</div>
                <f7-input outline type="text" placeholder="p. ej. cuartoMaquinas" :value="nuevaCaract.nombre" @input="nuevaCaract.nombre = $event.target.value"></f7-input>
              </f7-col>
              <f7-col width="100" medium="50" small="100" class="padding-right-half">
                <div class="caract-label">Etiqueta</div>
                <f7-input outline type="text" placeholder="Texto visible al usuario" :value="nuevaCaract.label" @input="nuevaCaract.label = $event.target.value"></f7-input>
              </f7-col>
              <f7-col width="100" medium="50" small="100" class="padding-right-half">
                <div class="caract-label">Tipo</div>
                <f7-input outline type="select" :value="nuevaCaract.tipo" @input="nuevaCaract.tipo = $event.target.value">
                  <option v-for="t in tiposCaracteristica" :key="t" :value="t">{{ t }}</option>
                </f7-input>
              </f7-col>
              <f7-col width="100" medium="50" small="100" class="padding-right-half">
                <div class="caract-label">Aliases (separados por coma)</div>
                <f7-input outline type="text" placeholder="alias1, alias2" :value="nuevaCaract.aliasesText" @input="nuevaCaract.aliasesText = $event.target.value"></f7-input>
              </f7-col>
              <f7-col width="100">
                <div class="caract-label">Descripción</div>
                <f7-input outline type="textarea" placeholder="Para qué sirve este campo" :value="nuevaCaract.descripcion" @input="nuevaCaract.descripcion = $event.target.value"></f7-input>
              </f7-col>
            </f7-row>
            <f7-button fill :icon-f7="nuevaCaractModo === 'edicion' ? 'pencil' : 'checkmark_alt'" :text="nuevaCaractModo === 'edicion' ? 'Actualizar' : 'Añadir'" class="margin-top" @click="confirmarPopupCaracteristica"></f7-button>
            <div v-if="nuevaCaractModo === 'edicion'" class="text-color-orange" style="font-size:11px; margin-top:6px;">
              {{ avisoEdicionCaracteristica }}
            </div>
            <div v-else class="text-color-gray" style="font-size:11px; margin-top:6px;">
              La característica se añade en el nivel actual de la clasificación con bloqueo manual.
              Se guardará junto al resto de cambios al pulsar «Guardar».
            </div>
          </f7-card-content>
        </f7-card>
      </f7-page>
    </f7-popup>

    <!-- Popup: sugerir características desde formatos (clusters IA) -->
    <f7-popup class="popup-clusters-formatos" v-if="clustersPopupOpened" :opened="true" @popup:closed="cerrarClustersPopup">
      <f7-page>
        <f7-navbar>
          <f7-nav-title class="ia-text">Características desde formatos</f7-nav-title>
          <f7-nav-right><f7-link popup-close>Cerrar</f7-link></f7-nav-right>
        </f7-navbar>
        <div class="clusters-toolbar">
          <span class="text-color-gray" style="font-size:12px;">
            Elige el nombre canónico de cada característica; el resto de nombres quedarán como alias.
          </span>
          <f7-button small fill class="ia-btn" @click="aplicarClustersSeleccionados" :disabled="clustersCargando || !clustersFormatos.length">
            Añadir seleccionadas
          </f7-button>
        </div>
        <div v-if="clustersFormatos.length" class="clusters-filtro">
          <f7-button small round :fill="clustersFiltroGrupo === 'TODOS'" @click="clustersFiltroGrupo = 'TODOS'">Todos ({{ clustersFormatos.length }})</f7-button>
          <f7-button small round :fill="clustersFiltroGrupo === 'IDENTIFICACION'" @click="clustersFiltroGrupo = 'IDENTIFICACION'">Identificación ({{ contarClustersPorCategoria('IDENTIFICACION') }})</f7-button>
          <f7-button small round :fill="clustersFiltroGrupo === 'EMPLAZAMIENTO'" @click="clustersFiltroGrupo = 'EMPLAZAMIENTO'">Emplazamiento ({{ contarClustersPorCategoria('EMPLAZAMIENTO') }})</f7-button>
          <f7-button small round :fill="clustersFiltroGrupo === 'OTROS'" @click="clustersFiltroGrupo = 'OTROS'">Otros ({{ contarClustersPorCategoria('OTROS') }})</f7-button>
        </div>
        <div v-if="clustersPlantillaSugerida" class="cluster-plantilla" style="display:flex; flex-wrap:wrap; align-items:center; gap:8px; padding:8px 12px; background:#f3f7fb; border:1px solid #d4e3f2; border-radius:6px; margin:0 12px 8px;">
          <label class="cluster-check" style="display:flex; align-items:center; gap:6px;">
            <input type="checkbox" v-model="clustersAplicarPlantilla" />
            <span class="ia-text" style="font-size:12px;">Plantilla de ID sugerida</span>
          </label>
          <input class="rp-input" style="flex:1 1 100%; font-family:ui-monospace,'Cascadia Code',Consolas,monospace; font-size:12px;" v-model="clustersPlantillaSugerida" />
          <span v-if="clustersPlantillaExplicacion" class="text-color-gray" style="font-size:11px; flex-basis:100%;">{{ clustersPlantillaExplicacion }}</span>
        </div>
        <div v-if="clustersCargando" class="clusters-narracion">
          <r-ia-pensando :narracion="clustersNarracion" latin-default="Thinking" texto-default="Agrupando características…" />
          <f7-button small round color="red" :disabled="clustersCancelando" @click="cancelarClusters">
            {{ clustersCancelando ? 'Cancelando…' : 'Cancelar' }}
          </f7-button>
        </div>
        <div v-else-if="!clustersFormatos.length" class="text-color-gray padding">No se han encontrado características que agrupar.</div>
        <div v-else-if="!clustersFiltrados.length" class="text-color-gray padding">No hay características en esta categoría.</div>
        <div v-else class="clusters-lista">
          <div v-for="(cl, ci) in clustersFiltrados" :key="'cl-' + cl._idx" class="cluster-card" :class="{'cluster-off': !cl._incluir}">
            <div class="cluster-head">
              <label class="cluster-check"><input type="checkbox" v-model="cl._incluir" /></label>
              <label class="caract-label">Canónico</label>
              <select class="rp-input" v-model="cl._canonico">
                <option v-for="op in cl.opciones" :key="'op-'+ci+'-'+op" :value="op">{{ op }}</option>
              </select>
              <label class="caract-label">Grupo</label>
              <select class="rp-input" v-model="cl._grupo">
                <option v-for="g in gruposParaCluster" :key="'clg-'+ci+'-'+g.codigo" :value="g.codigo">{{ g.denominacion || g.codigo }}</option>
              </select>
              <!-- La IA no la devolvió en ningún cluster; la añade el backend por su cuenta para
                   que no se pierda en silencio. Se marca porque nadie la ha emparejado. -->
              <span v-if="cl.noAgrupadaPorIa" class="badge color-orange" style="font-size:9px;"
                    title="La IA no la agrupó; se ofrece tal cual, sin alias">sin agrupar</span>
            </div>
            <div class="cluster-aliases">
              <span class="text-color-gray" style="font-size:11px;">Alias:</span>
              <span v-for="(a, ai) in aliasesDeCluster(cl)" :key="'al-'+ci+'-'+ai" class="alias-badge">{{ a }}</span>
              <span v-if="!aliasesDeCluster(cl).length" class="text-color-gray" style="font-size:11px;">— sin alias —</span>
            </div>
            <div class="cluster-origen">
              <span v-for="(v, vi) in cl.variantes" :key="'va-'+ci+'-'+vi" class="cluster-origen-item" :title="(v.formatos || []).join(', ')">
                <code>{{ v.nombre }}</code> <span class="text-color-gray">({{ (v.formatos || []).length }})</span>
              </span>
            </div>
          </div>
        </div>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>

<script>
import ItemClasificacion from "./../../js/db/ItemClasificacion.js";
import ItemTipoClasificacion from "./../../js/db/ItemTipoClasificacion.js";
import Materia from "./../../js/db/Materia.js";
import Formato from "./../../js/db/Formato.js";
import RevisionFormatosEvents from "./../../js/db/RevisionFormatosEvents.js";
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import rAutocompleteM2m from "./../../components/rAutocompleteM2m.vue";
import rIaPensando from "./../../components/rIaPensando.vue";
import NaturalezasMaestro from "./../../js/utils/naturalezasMaestro.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";

export default {
  components: { rForm, rInput, rAutocompleteM2m, rIaPensando },
  data() {
    return {
      ItemClasificacion,
      ItemTipoClasificacion,
      Materia,
      Formato,
      id: this.$f7route.params.id,
      readonly: !this.editable,
      headerTipo: '',
      headerSubtipos: [],
      codigosDisponibles: [],
      naturalezas: [],
      naturalezaBgByCode: {},
      gruposResueltos: [],
      cargandoGruposResueltos: false,
      // --- Discriminantes de subtipo ---
      OPERADORES_DISC: ['IN', 'IGUAL', 'NOT_IN', 'CONTIENE', 'MAYOR', 'MAYOR_IGUAL', 'MENOR', 'MENOR_IGUAL', 'ENTRE', 'EXISTE'],
      discCatalogo: [],        // características discriminables del tipo, con sus opciones declaradas
      discEmpates: [],
      discCargando: false,
      discNarracion: null,
      discPropuestaPendiente: false,
      reclasEnCurso: false,
      reclasNarracion: null,
      reclasCambiados: 0,
      tipologiaClasificacion: { tipo: '', subtipos: [], plantillaIdItem: '', plantillaIdItemOrigen: [] },
      // Mapa "grupoCodigo|nombreCaracteristica" → { accion, rutaDestino:[], manualOverride:bool, rutaOrigen:[], ... }
      cambiosCaracteristicas: {},
      // Tokens de la dirección del expediente disponibles para la plantilla de ID.
      // El back los resuelve por reflexión sobre expediente.direccionInspeccion (DireccionEMO),
      // así que cualquier campo de esa dirección es un token válido.
      tokensEmplazamiento: [
        { nombre: 'direccionInspeccion.direccion', label: 'Dirección' },
        { nombre: 'direccionInspeccion.cp', label: 'C.P.' },
        { nombre: 'direccionInspeccion.poblacion', label: 'Población' },
        { nombre: 'direccionInspeccion.provincia', label: 'Provincia' },
        { nombre: 'direccionInspeccion.provinciaStr', label: 'Provincia (texto)' },
        { nombre: 'direccionInspeccion.provinciaCod', label: 'Provincia (cód.)' },
        { nombre: 'direccionInspeccion.comunidad', label: 'Comunidad' },
        { nombre: 'direccionInspeccion.comunidadStr', label: 'Comunidad (texto)' },
        { nombre: 'direccionInspeccion.comunidadCod', label: 'Comunidad (cód.)' },
        { nombre: 'direccionInspeccion.pais', label: 'País' },
        { nombre: 'direccionInspeccion.paisStr', label: 'País (texto)' },
        { nombre: 'direccionInspeccion.paisCod', label: 'País (cód.)' },
        { nombre: 'direccionInspeccion.placeId', label: 'Place ID (Google)' },
        { nombre: 'direccionInspeccion.direccionNormalizada', label: 'Dirección normalizada' }
      ],
      // Paleta para colorear los tokens por grupo de características (cíclica).
      tokenPaleta: ['#1976d2', '#388e3c', '#d32f2f', '#7b1fa2', '#f57c00', '#0097a7', '#c2185b', '#5d4037', '#455a64', '#afb42b'],
      // Sugerencia de características desde formatos (clusters IA)
      clustersPopupOpened: false,
      clustersCargando: false,
      clustersFormatos: [],
      clustersFiltroGrupo: 'TODOS',
      clustersPlantillaSugerida: '',
      clustersPlantillaExplicacion: '',
      clustersAplicarPlantilla: true,
      clustersNarracion: null,
      clustersCancelando: false,
      clustersGruposExtra: [],  // grupos temáticos derivados de subgrupos (características con hijas)
      // --- Administración manual (drag & drop, grupos, chips de formato) ---
      dragItem: null,           // {kind:'car', grupoCodigo, nombre, c} | {kind:'chip', nombre, info}
      formatoChipsRaw: [],      // [{codigo, nombre, caracteristicas:[TODAS]}] por formato (se filtra en computed)
      formatoChipsColapsados: {}, // codigo de formato → true si está plegado
      todosChipsColapsados: false,
      cargandoChips: false,
      formatoCarsPorNombre: {}, // nombre normalizado de característica → [códigos de formato que la tienen]
      nuevoTipoPopupOpened: false,
      nuevaCaractPopupOpened: false,
      nuevaCaractModo: 'alta', // 'alta' | 'edicion'
      nuevaCaractGrupo: null,
      nuevaCaractOriginal: null, // referencia a la CaracteristicaResuelta cuando editamos
      nuevaCaract: { nombre: '', label: '', tipo: 'TEXT', descripcion: '', aliasesText: '' },
      colorOptions: [
        'blue','teal','green','orange','red','purple','pink','deeporange','brown','indigo','lime','yellow','deeppurple','lightblue','gray'
      ],
      coloresHex: {
        blue: '#2196f3', teal: '#009688', green: '#4caf50', orange: '#ff9800', red: '#f44336',
        purple: '#9c27b0', pink: '#e91e63', deeporange: '#ff5722', brown: '#795548', indigo: '#3f51b5',
        lime: '#cddc39', yellow: '#ffeb3b', deeppurple: '#673ab7', lightblue: '#03a9f4', gray: '#9e9e9e'
      },
      nuevoTipoDefault: {
        codigo: '',
        denominacion: '',
        naturalezaDefault: 'FIJ',
        reglamentoDefault: '',
        itcDefault: '',
        colorBadge: 'gray',
        observaciones: ''
      },
      tiposCaracteristica: [
        'TEXT', 'TEXTAREA', 'NUMBER', 'DATE', 'CHECK', 'RADIO',
        'SIMPLELIST', 'MULTILIST', 'MULTICHECK', 'NOTA', 'GROUP',
        'TABLA', 'TABLA_DINAMICA', 'TABLA_PERSONALIZADA',
        'FIRMA', 'TRANSFORMADOR', 'AUTOCALCULADO', 'COMPROBACION'
      ],
      defaultData: {
        codigo: '',
        denominacion: '',
        naturaleza: '',
        reglamento: '',
        itc: '',
        subtipos: [],
        materias: [],
        formatosUsados: [],
        grupos: [
          { codigo: 'IDENTIFICACION', denominacion: 'Identificación', orden: 1, obligatorio: true, caracteristicas: [] },
          { codigo: 'EMPLAZAMIENTO',  denominacion: 'Emplazamiento',  orden: 2, obligatorio: true, caracteristicas: [] }
        ],
        observaciones: '',
        estadoTipificacion: 'TIPIFICADO'
      }
    };
  },
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    tituloDetalle() {
      var tipo = this.headerTipo || '';
      var subs = (this.headerSubtipos && this.headerSubtipos.length) ? this.headerSubtipos.join(' / ') : '';
      return 'Clasificación' + (tipo ? ': ' + tipo : '') + (subs ? ' - ' + subs : '');
    },
    hayCambiosCaracteristicas() {
      return Object.keys(this.cambiosCaracteristicas).length > 0;
    },
    // Nombres (normalizados) ya asignados en la clasificación, como nombre o alias.
    nombresPresentesSet() {
      var self = this;
      var set = {};
      (this.gruposMostrar || []).forEach(function (g) {
        (self.caracteristicasEfectivas(g) || []).forEach(function (c) {
          set[self._norm(c.nombre)] = 1;
          (c.aliases || []).forEach(function (a) { set[self._norm(a)] = 1; });
        });
      });
      return set;
    },
    // Chips de formato a mostrar: por formato, SOLO las características no asignadas (ni nombre
    // ni alias). Se recalcula solo al asignar/añadir, y descarta los formatos que quedan vacíos.
    formatoChipsGrupos() {
      var self = this;
      var presentes = this.nombresPresentesSet;
      return (this.formatoChipsRaw || []).map(function (fg) {
        var faltan = (fg.caracteristicas || []).filter(function (it) {
          return it && it.nombre && !presentes[self._norm(it.nombre)];
        });
        return { codigo: fg.codigo, nombre: fg.nombre, caracteristicas: faltan };
      }).filter(function (fg) { return fg.caracteristicas.length; });
    },
    gruposParaCluster() {
      // Grupos donde colocar las características sugeridas: los resueltos + garantía de
      // IDENTIFICACION y EMPLAZAMIENTO aunque aún no estén resueltos.
      var out = [];
      var vistos = {};
      (this.gruposResueltos || []).forEach(function (g) {
        if (g.codigo && !vistos[g.codigo]) { vistos[g.codigo] = 1; out.push({ codigo: g.codigo, denominacion: g.denominacion }); }
      });
      // Grupos temáticos extra propuestos por la IA (de las características con hijas).
      (this.clustersGruposExtra || []).forEach(function (g) {
        if (g && g.codigo && !vistos[g.codigo]) { vistos[g.codigo] = 1; out.push({ codigo: g.codigo, denominacion: g.denominacion || g.codigo }); }
      });
      [['IDENTIFICACION', 'Identificación'], ['EMPLAZAMIENTO', 'Emplazamiento'], ['TITULARIDAD', 'Titularidad'], ['OTROS', 'Otros']].forEach(function (d) {
        if (!vistos[d[0]]) { vistos[d[0]] = 1; out.push({ codigo: d[0], denominacion: d[1] }); }
      });
      return out;
    },
    // Grupos a MOSTRAR en "Grupos de características": los resueltos del catálogo + los que solo
    // tienen altas pendientes (CREAR) todavía sin guardar (p. ej. tras "Sugerir características"
    // sobre una clasificación sin tipologías aún). Sin esto, las pendientes no se ven.
    gruposMostrar() {
      var cambios = this.cambiosCaracteristicas;
      var eliminados = {}, renombrados = {};
      Object.values(cambios).forEach(function (p) {
        if (!p) return;
        if (p.accion === 'ELIMINAR_GRUPO' && p.grupoCodigo) eliminados[p.grupoCodigo] = 1;
        if (p.accion === 'RENOMBRAR_GRUPO' && p.grupoCodigo) renombrados[p.grupoCodigo] = p.grupoDenominacion;
      });
      var out = [];
      var vistos = {};
      (this.gruposResueltos || []).forEach(function (g) {
        if (g.codigo && eliminados[g.codigo]) return; // borrado pendiente
        if (g.codigo) vistos[g.codigo] = 1;
        if (g.codigo && renombrados[g.codigo] != null) {
          out.push(Object.assign({}, g, { denominacion: renombrados[g.codigo] }));
        } else {
          out.push(g);
        }
      });
      var extra = [];
      Object.values(cambios).forEach(function (p) {
        if (!p || (p.accion !== 'CREAR' && p.accion !== 'CREAR_GRUPO') || !p.grupoCodigo || vistos[p.grupoCodigo]) return;
        vistos[p.grupoCodigo] = 1;
        extra.push({
          codigo: p.grupoCodigo,
          denominacion: (renombrados[p.grupoCodigo] != null ? renombrados[p.grupoCodigo] : (p.grupoDenominacion || p.grupoCodigo)),
          orden: (p.grupoOrden != null ? p.grupoOrden : null),
          obligatorio: !!p.grupoObligatorio,
          caracteristicas: [],
          _soloPendiente: true
        });
      });
      extra.sort(function (a, b) { return (a.orden == null ? 9999 : a.orden) - (b.orden == null ? 9999 : b.orden); });
      return out.concat(extra);
    },
    // Clusters filtrados por la categoría seleccionada (TODOS / IDENTIFICACION / EMPLAZAMIENTO / OTROS).
    clustersFiltrados() {
      var self = this;
      if (!this.clustersFiltroGrupo || this.clustersFiltroGrupo === 'TODOS') return this.clustersFormatos;
      return this.clustersFormatos.filter(function (cl) { return self.categoriaCluster(cl) === self.clustersFiltroGrupo; });
    },
    hayCambioPlantillaPendiente() {
      return !!this.cambiosCaracteristicas.__PLANTILLA_ID__;
    },
    plantillaIdEfectiva() {
      var pendiente = this.cambiosCaracteristicas.__PLANTILLA_ID__;
      if (pendiente) return pendiente.plantillaIdItem || '';
      return this.tipologiaClasificacion.plantillaIdItem || '';
    },
    nivelPlantillaEfectivo() {
      // Profundidad (nº de subtipos activos) donde vive/vivirá la plantilla.
      var pendiente = this.cambiosCaracteristicas.__PLANTILLA_ID__;
      if (pendiente && Array.isArray(pendiente.rutaDestino)) return pendiente.rutaDestino.length;
      if (this.tipologiaClasificacion.plantillaIdItem) {
        return (this.tipologiaClasificacion.plantillaIdItemOrigen || []).length;
      }
      return 0;
    },
    tokensCaractPorGrupo() {
      // Características (de todos los grupos resueltos, incl. altas pendientes) como tokens
      // insertables, agrupadas por su grupo para mostrarlas en filas separadas y con color
      // propio. Dedup por nombre (case-insensitive) a través de todos los grupos.
      var tipo = this.tipologiaClasificacion.tipo || '';
      var self = this;
      var vistos = {};
      var secciones = [];
      this.gruposMostrar.forEach(function (grupo) {
        var tokens = [];
        self.caracteristicasEfectivas(grupo)
          .filter(function (c) { return c.nombre && !self.estaCaracteristicaMarcadaParaBorrar(grupo.codigo, c.nombre); })
          .forEach(function (c) {
            var clave = c.nombre.toLowerCase();
            if (vistos[clave]) return;
            vistos[clave] = true;
            var ruta = c.rutaActual || [];
            tokens.push({
              nombre: c.nombre,
              label: c.label || '',
              nivelTitulo: (grupo.denominacion || grupo.codigo) + ' · '
                + (ruta.length ? tipo + ' / ' + ruta.join(' / ') : tipo + ' (raíz)')
            });
          });
        if (tokens.length) {
          secciones.push({ codigo: grupo.codigo, denominacion: grupo.denominacion || grupo.codigo, tokens: tokens });
        }
      });
      return secciones;
    },
    avisoEdicionCaracteristica() {
      if (this.nuevaCaractModo !== 'edicion' || !this.nuevaCaractOriginal) return '';
      var ruta = this.nuevaCaractOriginal.rutaActual || [];
      var nivel = ruta.length === 0
        ? '«' + (this.tipologiaClasificacion.tipo || '') + '» (raíz)'
        : '«' + (this.tipologiaClasificacion.tipo || '') + ' / ' + ruta.join(' / ') + '»';
      return 'Los cambios se aplican en ' + nivel + ' y afectarán a todas las clasificaciones que hereden esta característica.';
    }
  },
  mounted() {
    var self = this;
    this.cargarCodigos();
    NaturalezasMaestro.load().then(function (m) {
      self.naturalezas = m.items;
      self.naturalezaBgByCode = m.bgColorByCode;
    });
  },
  beforeDestroy() {
    if (this._agruparHandler) RevisionFormatosEvents.unsubscribe(this._agruparHandler);
    // Si se sale con una revisión o reclasificación en marcha, el trabajo sigue en el servidor:
    // aquí solo soltamos el handler para no escribir sobre un componente destruido. Al volver,
    // retomarReclasificacion() recupera el contador.
    if (this._discHandler) RevisionFormatosEvents.unsubscribe(this._discHandler);
  },
  methods: {
    // ------------------------------------------------------------------
    // Discriminantes de subtipo
    // ------------------------------------------------------------------
    cargarDiscriminantes() {
      const self = this;
      if (!self.id) return;
      ItemClasificacion.catalogoDiscriminantes(self.id).then(function (res) {
        self.discCatalogo = (res && res.caracteristicas) || [];
      }).catch(function () { self.discCatalogo = []; });
      ItemClasificacion.empatesDiscriminantes(null, self.id).then(function (res) {
        self.discEmpates = (res && res.empates) || [];
      }).catch(function () { self.discEmpates = []; });
    },
    /** Opciones declaradas de una característica, unidas de todos los formatos del tipo. */
    opcionesDeclaradas(nombre) {
      var clave = (nombre || '').trim();
      var cat = this.discCatalogo.find(function (c) { return (c.nombre || '').trim() === clave; });
      if (!cat) return [];
      var out = [];
      (cat.opcionesPorFormato || []).forEach(function (of) {
        (of.opciones || []).forEach(function (o) { if (out.indexOf(o) < 0) out.push(o); });
      });
      return out;
    },
    opcionesParaAnadir(cond) {
      var ya = cond.valores || [];
      return this.opcionesDeclaradas(cond.caracteristica).filter(function (o) { return ya.indexOf(o) < 0; });
    },
    esOperadorNumerico(op) {
      return ['MAYOR', 'MAYOR_IGUAL', 'MENOR', 'MENOR_IGUAL', 'ENTRE'].indexOf(op) >= 0;
    },
    etiquetaOperador(op) {
      var m = {
        IN: 'contiene alguno de', IGUAL: 'es igual a', NOT_IN: 'no es ninguno de',
        CONTIENE: 'contiene', MAYOR: 'es mayor que', MAYOR_IGUAL: 'es mayor o igual que',
        MENOR: 'es menor que', MENOR_IGUAL: 'es menor o igual que', ENTRE: 'está entre', EXISTE: 'está relleno'
      };
      return m[op] || op;
    },
    ayudaOperador(op) {
      if (this.esOperadorNumerico(op)) return 'Compara el número del campo con el valor indicado.';
      if (op === 'EXISTE') return 'Se cumple si el campo tiene cualquier valor.';
      if (op === 'CONTIENE' || op === 'IN') return 'Se cumple si el valor del campo incluye alguno de los listados (campos de varias opciones).';
      if (op === 'NOT_IN') return 'Se cumple si el valor NO es ninguno de los listados.';
      return 'Se cumple si el valor del campo coincide con el indicado.';
    },
    anadirValorSelect(cond, ev) {
      var v = ev && ev.target ? ev.target.value : '';
      if (!v) return;
      if (!cond.valores) this.$set(cond, 'valores', []);
      if (cond.valores.indexOf(v) < 0) cond.valores.push(v);
      ev.target.value = '';
    },
    anadirValorTexto(cond, ev) {
      var v = ev && ev.target ? (ev.target.value || '').trim() : '';
      if (!v) return;
      if (!cond.valores) this.$set(cond, 'valores', []);
      if (cond.valores.indexOf(v) < 0) cond.valores.push(v);
      ev.target.value = '';
    },
    anadirCondicion(rform) {
      if (!Array.isArray(rform.formData.condicionesDiscriminacion)) {
        this.$set(rform.formData, 'condicionesDiscriminacion', []);
      }
      rform.formData.condicionesDiscriminacion.push({
        caracteristica: this.discCatalogo.length ? this.discCatalogo[0].nombre : '',
        operador: 'CONTIENE',
        valores: [],
        valorNumerico: null,
        valorNumericoHasta: null,
        unidad: null,
        origen: 'MANUAL',
        justificacion: ''
      });
    },
    irADiscriminantes() {
      var el = document.getElementById('card-discriminantes');
      if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    /**
     * Recalcula las condiciones SOLO de esta clasificación. La IA recibe a las hermanas con sus
     * condiciones ya guardadas como contexto (sin ellas no hay de qué distinguirla), pero solo
     * propone para esta. La propuesta no se guarda: queda pendiente del "Guardar" de la cabecera.
     */
    recalcularDiscriminantes() {
      const self = this;
      if (!self.id) return;
      if (self.readonly) self.readonly = false;   // la propuesta hay que poder revisarla y guardarla
      self.discCargando = true;
      self.discPropuestaPendiente = false;
      self.discNarracion = { latin: 'Starting', texto: 'Lanzando la revisión…', hechos: 0, total: 0 };
      if (!self._discHandler) self._discHandler = self._onDiscEvent.bind(self);
      ItemClasificacion.revisarDiscriminantes(null, self.id).then(function (res) {
        RevisionFormatosEvents.subscribe(self._discHandler, self.$f7);
        if (res && res.lanzado === false) {
          self.discCargando = false;
          self.discNarracion = null;
          self.$f7.dialog.alert(res.error || 'Ya hay una revisión en curso.', 'No se pudo lanzar');
        }
      }).catch(function (err) {
        self.discCargando = false;
        self.discNarracion = null;
        self.$f7.dialog.alert(self._msgErrorDisc(err), 'Error lanzando la revisión');
      });
    },
    _onDiscEvent(payload) {
      const self = this;
      if (!payload || typeof payload !== 'object') return;
      if (payload.accion !== 'discriminantes') return;
      // El canal es compartido: solo reaccionamos a lo de ESTA clasificación.
      if (payload.idDiana && payload.idDiana !== self.id) return;
      // Dos trabajos distintos viajan por el mismo canal: la propuesta y la reclasificación.
      if (payload.fase === 'reclasificar') return self._onReclasEvent(payload);

      if (payload.estado === 'progreso') {
        self.discNarracion = { latin: payload.latin, texto: payload.texto, hechos: payload.hechos, total: payload.total };
        return;
      }
      self.discCargando = false;
      self.discNarracion = null;
      RevisionFormatosEvents.unsubscribe(self._discHandler);

      if (payload.estado === 'error') {
        self.$f7.dialog.alert(payload.texto || 'Error revisando las condiciones.', 'Error');
        return;
      }
      if (payload.estado === 'cancelado') {
        self.$f7.toast.create({ text: 'Revisión cancelada.', closeTimeout: 2500 }).open();
        return;
      }
      var r = payload.resultado || {};
      if (r.caracteristicas && r.caracteristicas.length) self.discCatalogo = r.caracteristicas;
      var prop = (r.propuestas || []).find(function (p) { return p.clasificacionId === self.id; });
      var nuevas = prop ? (prop.condiciones || []) : [];
      var rform = self.$refs.rform;
      var actuales = (rform && rform.formData && rform.formData.condicionesDiscriminacion) || [];

      // La IA no propone nada. Si ya había condiciones NO se tocan: normalmente significa "las
      // que tienes ya son las correctas", y borrarlas aquí sería perder trabajo sin pedirlo.
      if (!nuevas.length) {
        self.mostrarExplicacionIa(actuales.length
          ? 'La IA no propone cambios; se mantienen las condiciones actuales.'
          : 'La IA no ha propuesto condiciones para este subtipo.', r.observaciones);
        return;
      }

      if (!rform || !rform.formData) return;
      // Se muta la lista existente para que el slot del formulario refresque.
      if (!Array.isArray(rform.formData.condicionesDiscriminacion)) {
        self.$set(rform.formData, 'condicionesDiscriminacion', []);
      }
      rform.formData.condicionesDiscriminacion.splice(0);
      nuevas.forEach(function (c) {
        rform.formData.condicionesDiscriminacion.push({
          caracteristica: c.caracteristica,
          operador: c.operador || 'CONTIENE',
          valores: c.valores || [],
          valorNumerico: c.valorNumerico != null ? c.valorNumerico : null,
          valorNumericoHasta: c.valorNumericoHasta != null ? c.valorNumericoHasta : null,
          unidad: c.unidad || null,
          origen: 'IA',
          justificacion: c.justificacion || ''
        });
      });
      self.discPropuestaPendiente = true;
      if (r.observaciones) self.mostrarExplicacionIa('Propuesta aplicada al formulario.', r.observaciones);
    },
    /**
     * Explicación de la IA en un diálogo: suele ser un párrafo largo y en un toast no da tiempo
     * a leerlo. Se cierra con Aceptar, no solo.
     */
    mostrarExplicacionIa(titulo, observaciones) {
      var texto = observaciones && observaciones.trim()
        ? observaciones.replace(/\n/g, '<br>')
        : '(sin más detalle)';
      this.$f7.dialog.alert('<div class="disc-dialog-texto">' + texto + '</div>', titulo);
    },
    cancelarDiscriminantes() {
      ItemClasificacion.cancelarDiscriminantes().catch(function () { /* best-effort */ });
      this.$f7.toast.create({ text: 'Cancelando…', closeTimeout: 2000 }).open();
    },
    /**
     * Reclasifica los items del tipo. Alcance: TODO el tipo, no solo los de esta clasificación —
     * al cambiar una condición un item de una hermana puede pasar a esta y viceversa.
     * Corre en segundo plano y se narra por SSE: con cientos de items un POST síncrono agotaría
     * el timeout y el usuario no sabría si avanza.
     */
    reclasificarAfectados() {
      const self = this;
      if (!self.id) return;
      ItemClasificacion.afectadosDiscriminantes(self.id).then(function (info) {
        var total = (info && info.total) || 0;
        if (!total) {
          self.$f7.toast.create({ text: 'No hay items de este tipo que reclasificar.', closeTimeout: 3000 }).open();
          return;
        }
        self.$f7.dialog.confirm(
          'Se reclasificarán ' + total + ' item(s) del tipo ' + ((info && info.codigoTipo) || '') + '.<br><br>'
          + '<b>Ojo:</b> la reclasificación re-sincroniza el expediente, así que <b>pisa las ediciones '
          + 'manuales</b> de características y roles de esos items. ¿Continuar?',
          'Reclasificar items',
          function () {
            self.reclasNarracion = { latin: 'Starting', texto: 'Lanzando la reclasificación…', hechos: 0, total: total };
            self.reclasCambiados = 0;
            self.reclasEnCurso = true;
            if (!self._discHandler) self._discHandler = self._onDiscEvent.bind(self);
            ItemClasificacion.reclasificarPorDiscriminantes(self.id).then(function (res) {
              RevisionFormatosEvents.subscribe(self._discHandler, self.$f7);
              if (res && res.lanzado === false) {
                self.reclasEnCurso = false;
                self.reclasNarracion = null;
                self.$f7.dialog.alert('Ya hay una reclasificación en curso.', 'No se pudo lanzar');
              }
            }).catch(function (err) {
              self.reclasEnCurso = false;
              self.reclasNarracion = null;
              self.$f7.dialog.alert(self._msgErrorDisc(err), 'Error reclasificando');
            });
          }
        );
      }).catch(function (err) {
        self.$f7.dialog.alert(self._msgErrorDisc(err), 'Error consultando los items afectados');
      });
    },
    _onReclasEvent(payload) {
      const self = this;
      self.reclasCambiados = payload.cambiados || 0;
      if (payload.estado === 'progreso') {
        self.reclasEnCurso = true;
        self.reclasNarracion = {
          latin: payload.latin, texto: payload.texto,
          hechos: payload.hechos, total: payload.total
        };
        return;
      }
      self.reclasEnCurso = false;
      self.reclasNarracion = null;
      RevisionFormatosEvents.unsubscribe(self._discHandler);

      if (payload.estado === 'error') {
        self.$f7.dialog.alert(payload.texto || 'Error reclasificando.', 'Error');
        return;
      }
      var resumen = payload.resumen || {};
      var errores = resumen.errores || [];
      self.$f7.toast.create({
        text: (payload.estado === 'cancelado' ? 'Cancelada. ' : '') + payload.texto,
        closeTimeout: 5000, closeButton: true
      }).open();
      if (errores.length) self.$f7.dialog.alert(errores.slice(0, 10).join('\n'), 'Errores al reclasificar');
      // Los empates pueden haber cambiado con la reclasificación.
      self.cargarDiscriminantes();
    },
    cancelarReclasificacion() {
      ItemClasificacion.cancelarReclasificacionDiscriminantes().catch(function () { /* best-effort */ });
      this.$f7.toast.create({ text: 'Cancelando… se detendrá al terminar el item en curso.', closeTimeout: 3000 }).open();
    },
    /**
     * Al entrar en la ficha, si hay una reclasificación de ESTA clasificación en marcha, se
     * retoma el contador donde iba: al navegar fuera y volver no debe parecer que no pasa nada.
     */
    retomarReclasificacion() {
      const self = this;
      if (!self.id) return;
      ItemClasificacion.estadoReclasificacionDiscriminantes().then(function (est) {
        if (!est || !est.enCurso || est.idClasificacion !== self.id) return;
        self.reclasEnCurso = true;
        self.reclasCambiados = est.cambiados || 0;
        self.reclasNarracion = {
          latin: 'Reclassifying', texto: 'Reclasificando items…',
          hechos: est.hechos || 0, total: est.total || 0
        };
        if (!self._discHandler) self._discHandler = self._onDiscEvent.bind(self);
        RevisionFormatosEvents.subscribe(self._discHandler, self.$f7);
      }).catch(function () { /* informativo */ });
    },
    /** Tras guardar condiciones nuevas, ofrecer aplicarlas a los items ya clasificados. */
    ofrecerReclasificar() {
      const self = this;
      self.$f7.dialog.confirm(
        'Condiciones guardadas. ¿Quieres reclasificar ahora los items de este tipo para aplicarlas?',
        'Reclasificar items',
        function () { self.reclasificarAfectados(); }
      );
    },
    _msgErrorDisc(err) {
      if (!err) return 'Error desconocido.';
      if (typeof err === 'string') return err;
      return err.message || err.error || JSON.stringify(err);
    },
    onLoadItem(item) {
      // Capturamos tipo y subtipos del item cargado para el título en modo lectura.
      this.headerTipo = (item && item.codigo) || '';
      this.headerSubtipos = (item && Array.isArray(item.subtipos)) ? item.subtipos.slice() : [];
      // Cargamos los grupos de características resueltos por tipología.
      this.cargarGruposResueltos();
      // Discriminantes: opciones declaradas (para editar los valores) y empates registrados.
      this.cargarDiscriminantes();
      // Si había una reclasificación en marcha, se retoma el contador donde iba.
      this.retomarReclasificacion();
      // El campo puede no existir en clasificaciones anteriores a la feature.
      if (item && !Array.isArray(item.condicionesDiscriminacion)) {
        this.$set(item, 'condicionesDiscriminacion', []);
      }
      // De qué formatos procede cada característica (para mostrarlo junto a su nombre).
      this.cargarFormatosOrigen(this.codigosFormatosUsados({ formData: item }));
      // Para cada característica de cada grupo, "desplegamos" aliases[] a aliasesText
      // para que el input texto del form lo edite como string separado por comas.
      if (item && Array.isArray(item.grupos)) {
        item.grupos.forEach(function (g) {
          if (!g.caracteristicas) return;
          g.caracteristicas.forEach(function (c) {
            c.aliasesText = Array.isArray(c.aliases) ? c.aliases.join(', ') : '';
          });
        });
      }
      // Garantizamos que el <option> del codigo cargado exista en el select aunque
      // cargarCodigos() no haya terminado todavía (evita que el select se vea vacío).
      if (item && item.codigo && !this.codigosDisponibles.some(c => c.codigo === item.codigo)) {
        this.codigosDisponibles.push({
          codigo: item.codigo,
          denominacion: item.denominacion || '',
          naturalezaDefault: item.naturaleza || '',
          reglamentoDefault: item.reglamento || '',
          itcDefault: item.itc || '',
          colorBadge: 'gray'
        });
      }
    },
    colorOptionStyle(c) {
      var bg = this.coloresHex[c] || c;
      // texto oscuro sobre colores claros para que sea legible
      var claros = ['lime', 'yellow', 'lightblue', 'gray'];
      var fg = claros.indexOf(c) >= 0 ? '#000' : '#fff';
      return { backgroundColor: bg, color: fg };
    },
    cancelarEdicion() {
      // Descartamos cambios no guardados y volvemos a modo lectura.
      if (this.$refs.rform && typeof this.$refs.rform.cancelEdit === 'function') {
        this.$refs.rform.cancelEdit();
      }
      this.readonly = true;
    },
    subtiposRelleno(len) {
      // Devuelve el número de huecos necesarios para que la última fila quede alineada a 4 columnas.
      // 1→3, 2→2, 3→1, 4→0, 5→3, 6→2, 7→1, 8→0, ...
      if (!len) return 0;
      return (4 - (len % 4)) % 4;
    },
    naturalezaColor(nat) {
      // Color de fondo del select Naturaleza desde el configcombo ITEM_NATURALEZAS
      // (metadatos.bgColor). Fuente única para mantener consistencia con listados y badges.
      return this.naturalezaBgByCode[nat] || 'transparent';
    },
    cargarGruposResueltos() {
      const self = this;
      if (!self.id) {
        self.gruposResueltos = [];
        return;
      }
      self.cargandoGruposResueltos = true;
      // Llamada directa al endpoint /itemclasificacion/{id}/caracteristicas-resueltas.
      const url = ItemClasificacion.server_movilidad + ItemClasificacion.prefix
        + ItemClasificacion.model + '/' + encodeURIComponent(self.id) + '/caracteristicas-resueltas';
      var params = { url: url, method: 'GET', crossDomain: true, dataType: 'json' };
      try {
        var session = JSON.parse(localStorage.getItem('session') || 'null');
        var token = session && (session.token || session.access_token);
        if (token) params.headers = { Authorization: 'Bearer ' + token };
      } catch (e) {}
      ItemClasificacion.request.promise(params)
        .then(function (res) {
          var body = res && res.data;
          console.log('[caracteristicas-resueltas] body=', body);
          if (body && body.error) {
            console.warn('[caracteristicas-resueltas] error del back:', body.error);
          }
          // Nuevo formato (response GruposResueltosResponseDTO):
          //   { dto: { tipo, subtipos, grupos:[...] }, list:[], ... }
          // Formato antiguo (cuando el endpoint devolvía List<GrupoResueltoDTO>):
          //   { dto:null, list:[GrupoResueltoDTO...] }
          // Mantenemos compatibilidad temporal con el formato antiguo por si el back
          // no se ha redeployado.
          var dto = body && body.dto;
          if (dto && (dto.grupos || dto.tipo)) {
            self.tipologiaClasificacion = {
              tipo: dto.tipo || '',
              subtipos: Array.isArray(dto.subtipos) ? dto.subtipos : [],
              plantillaIdItem: dto.plantillaIdItem || '',
              plantillaIdItemOrigen: Array.isArray(dto.plantillaIdItemOrigen) ? dto.plantillaIdItemOrigen : []
            };
            self.gruposResueltos = Array.isArray(dto.grupos) ? dto.grupos : [];
          } else if (body && Array.isArray(body.list)) {
            // Formato antiguo: el back devuelve la lista sin meta de tipología.
            self.tipologiaClasificacion = {
              tipo: self.headerTipo || '',
              subtipos: (self.headerSubtipos || []).slice()
            };
            self.gruposResueltos = body.list;
          } else {
            self.tipologiaClasificacion = { tipo: self.headerTipo || '', subtipos: (self.headerSubtipos || []).slice() };
            self.gruposResueltos = [];
          }
          self.cambiosCaracteristicas = {};
        })
        .catch(function (err) {
          console.log('caracteristicas-resueltas error', err);
          self.gruposResueltos = [];
          self.tipologiaClasificacion = { tipo: '', subtipos: [] };
        })
        .finally(function () {
          self.cargandoGruposResueltos = false;
        });
    },
    keyCambio(grupoCodigo, nombre) {
      return (grupoCodigo || '') + '|' + (nombre || '');
    },
    estaCaracteristicaCambiada(grupoCodigo, nombre) {
      return !!this.cambiosCaracteristicas[this.keyCambio(grupoCodigo, nombre)];
    },
    profundidadEfectiva(grupoCodigo, c) {
      // Si la característica está en el mapa de cambios, devuelve la profundidad pendiente.
      // En caso contrario, devuelve la profundidad actual del back.
      var k = this.keyCambio(grupoCodigo, c.nombre);
      var pendiente = this.cambiosCaracteristicas[k];
      if (pendiente && pendiente.rutaDestino) return pendiente.rutaDestino.length;
      return typeof c.profundidadActual === 'number' ? c.profundidadActual : 0;
    },
    manualEfectivo(grupoCodigo, c) {
      var k = this.keyCambio(grupoCodigo, c.nombre);
      var pendiente = this.cambiosCaracteristicas[k];
      if (pendiente && typeof pendiente.manualOverride === 'boolean') return pendiente.manualOverride;
      return !!c.manualOverride;
    },
    chipsDeCaracteristica(grupoCodigo, c) {
      var ruta = this.tipologiaClasificacion.subtipos || [];
      var tipo = this.tipologiaClasificacion.tipo || '';
      var profundidad = this.profundidadEfectiva(grupoCodigo, c);
      var manual = this.manualEfectivo(grupoCodigo, c);
      var chips = [];
      // Chip 0: raíz del tipo
      chips.push({
        label: tipo,
        activo: profundidad >= 0,
        manual: manual && profundidad === 0,
        titulo: 'Nivel: ' + tipo + ' (aplica a todo el tipo)'
      });
      for (var i = 0; i < ruta.length; i++) {
        chips.push({
          label: ruta[i],
          activo: profundidad >= (i + 1),
          manual: manual && profundidad === (i + 1),
          titulo: 'Nivel: ' + tipo + ' / ' + ruta.slice(0, i + 1).join(' / ')
        });
      }
      return chips;
    },
    onChipClick(grupo, c, indiceChip) {
      // Si es un alta pendiente, el click solo mueve la rutaDestino — la función
      // registrarCambio mantiene la acción CREAR. No avisamos por especialización
      // porque el alta es nuestra y no roba a nadie.
      var esAltaPendiente = this.estaCaracteristicaNueva(grupo.codigo, c.nombre);
      if (indiceChip === 0) {
        var profActual = this.profundidadEfectiva(grupo.codigo, c);
        if (profActual === 0) return;
        // Subir a raíz: no avisamos (generalizar es seguro).
        this.registrarCambio(grupo, c, 0, true);
        return;
      }
      var profActualEf = this.profundidadEfectiva(grupo.codigo, c);
      var nuevaProf;
      if (indiceChip <= profActualEf) {
        nuevaProf = indiceChip - 1;
      } else {
        nuevaProf = indiceChip;
      }
      // Aviso al especializar (bajar de nivel): la característica deja de aplicarse
      // a las clasificaciones hermanas del subtipo destino. El usuario debe ratificarlo.
      var esEspecializacion = !esAltaPendiente && nuevaProf > profActualEf;
      if (esEspecializacion) {
        var self = this;
        var rutaClas = this.tipologiaClasificacion.subtipos || [];
        var nuevoSubtipo = rutaClas[nuevaProf - 1];
        var subtipoHermano = rutaClas[profActualEf]; // primer nivel que se especializa
        var nivelOrigen = profActualEf === 0
          ? '«' + this.tipologiaClasificacion.tipo + '» (raíz)'
          : '«' + this.tipologiaClasificacion.tipo + ' / ' + rutaClas.slice(0, profActualEf).join(' / ') + '»';
        this.$f7.dialog.confirm(
          'La característica "' + (c.label || c.nombre) + '" vive ahora en ' + nivelOrigen
          + ', así que se aplica también a las clasificaciones hermanas de "'
          + subtipoHermano + '" (otros subtipos al mismo nivel).<br><br>'
          + 'Si la bajas a "' + nuevoSubtipo + '", dejará de aplicarse a esos hermanos. ¿Continuar?',
          'Especialización: dejará de aplicarse a los hermanos',
          function () { self.registrarCambio(grupo, c, nuevaProf, true); }
        );
        return;
      }
      this.registrarCambio(grupo, c, nuevaProf, true);
    },
    onToggleManual(grupo, c) {
      // Click en la M de un chip activo: alterna el flag manualOverride sin mover la característica.
      var k = this.keyCambio(grupo.codigo, c.nombre);
      var manualActual = this.manualEfectivo(grupo.codigo, c);
      this.registrarCambio(grupo, c, this.profundidadEfectiva(grupo.codigo, c), !manualActual);
      // Si tras el toggle, la profundidad coincide con la original y manualOverride coincide
      // con el original del back, no es un cambio real: lo eliminamos del mapa.
      var pendiente = this.cambiosCaracteristicas[k];
      var mismaProf = pendiente.rutaDestino.length === (typeof c.profundidadActual === 'number' ? c.profundidadActual : 0);
      var mismoManual = pendiente.manualOverride === !!c.manualOverride;
      if (mismaProf && mismoManual) this.$delete(this.cambiosCaracteristicas, k);
    },
    registrarCambio(grupo, c, nuevaProfundidad, manualOverride) {
      var subtiposClas = this.tipologiaClasificacion.subtipos || [];
      var rutaDestino = subtiposClas.slice(0, nuevaProfundidad);
      var rutaOrigen = (c.rutaActual || []).slice();
      var k = this.keyCambio(grupo.codigo, c.nombre);
      // Si ya hay un alta pendiente para esta característica, actualizamos su rutaDestino
      // y manualOverride sin convertirla en MOVER (sigue siendo CREAR).
      var existente = this.cambiosCaracteristicas[k];
      if (existente && existente.accion === 'CREAR') {
        this.$set(this.cambiosCaracteristicas, k, Object.assign({}, existente, {
          rutaOrigen: rutaDestino,
          rutaDestino: rutaDestino,
          manualOverride: !!manualOverride
        }));
        return;
      }
      this.$set(this.cambiosCaracteristicas, k, {
        accion: 'MOVER',
        tipo: this.tipologiaClasificacion.tipo,
        grupoCodigo: grupo.codigo,
        grupoDenominacion: grupo.denominacion,
        grupoOrden: grupo.orden,
        grupoObligatorio: !!grupo.obligatorio,
        nombreCaracteristica: c.nombre,
        rutaOrigen: rutaOrigen,
        rutaDestino: rutaDestino,
        manualOverride: !!manualOverride
      });
    },
    estaCaracteristicaMarcadaParaBorrar(grupoCodigo, nombre) {
      var p = this.cambiosCaracteristicas[this.keyCambio(grupoCodigo, nombre)];
      return !!(p && p.accion === 'ELIMINAR');
    },
    estaCaracteristicaNueva(grupoCodigo, nombre) {
      var p = this.cambiosCaracteristicas[this.keyCambio(grupoCodigo, nombre)];
      return !!(p && p.accion === 'CREAR');
    },
    caracteristicasEfectivas(grupo) {
      // Lista del back con overlay de cambios pendientes (EDITAR) + altas pendientes (CREAR).
      // No overlay del nombre porque las claves de cambiosCaracteristicas se basan en él;
      // el rename se ve tras guardar y refrescar.
      var rutaClas = this.tipologiaClasificacion.subtipos || [];
      var resultado = (grupo.caracteristicas || []).map(c => {
        var p = this.cambiosCaracteristicas[this.keyCambio(grupo.codigo, c.nombre)];
        if (!p || p.accion !== 'EDITAR') return c;
        return Object.assign({}, c, {
          label: p.label != null ? p.label : c.label,
          tipo: p.tipoCaracteristica || c.tipo,
          descripcion: p.descripcion != null ? p.descripcion : c.descripcion,
          aliases: p.aliases != null ? p.aliases : c.aliases,
          _nombreNuevo: p.nombreNuevo || null
        });
      });
      Object.values(this.cambiosCaracteristicas).forEach(p => {
        if (p.accion !== 'CREAR') return;
        if (p.grupoCodigo !== grupo.codigo) return;
        resultado.push({
          nombre: p.nombreCaracteristica,
          label: p.label || '',
          tipo: p.tipoCaracteristica || '',
          aliases: p.aliases || [],
          manualOverride: !!p.manualOverride,
          profundidadActual: rutaClas.length,
          rutaActual: rutaClas.slice()
        });
      });
      // Dedup defensivo por nombre dentro del grupo: como el borrado/edición se basan en
      // grupoCodigo|nombre, dos filas con el mismo nombre comparten clave y se marcarían a la vez.
      var vistos = {};
      return resultado.filter(function (c) {
        var k = (c.nombre || '').trim().toLowerCase();
        if (!k || vistos[k]) return false;
        vistos[k] = 1;
        return true;
      });
    },
    // ===================== Administración manual: grupos =====================
    nuevoGrupo() {
      const self = this;
      self.$f7.dialog.prompt('Nombre del nuevo grupo', 'Nuevo grupo', function (nombre) {
        var deno = (nombre || '').trim();
        if (!deno) return;
        var codigo = self._codigoGrupoDeno(deno);
        if (self.gruposMostrar.some(function (g) { return g.codigo === codigo; })) {
          self.$f7.dialog.alert('Ya existe un grupo con ese código (' + codigo + ').');
          return;
        }
        var maxOrden = self.gruposMostrar.reduce(function (m, g) { return Math.max(m, g.orden == null ? 0 : g.orden); }, 0);
        self.$set(self.cambiosCaracteristicas, '__CREARGRUPO__|' + codigo, {
          accion: 'CREAR_GRUPO',
          tipo: self.tipologiaClasificacion.tipo,
          grupoCodigo: codigo,
          grupoDenominacion: deno,
          grupoOrden: maxOrden + 1,
          grupoObligatorio: false,
          rutaDestino: (self.tipologiaClasificacion.subtipos || []).slice()
        });
      });
    },
    renombrarGrupo(g) {
      const self = this;
      self.$f7.dialog.prompt('Nuevo nombre del grupo «' + (g.denominacion || g.codigo) + '»', 'Renombrar grupo', function (nombre) {
        var deno = (nombre || '').trim();
        if (!deno || deno === g.denominacion) return;
        var kCrear = '__CREARGRUPO__|' + g.codigo;
        if (self.cambiosCaracteristicas[kCrear]) {
          self.$set(self.cambiosCaracteristicas, kCrear, Object.assign({}, self.cambiosCaracteristicas[kCrear], { grupoDenominacion: deno }));
          return;
        }
        self.$set(self.cambiosCaracteristicas, '__RENOMBRARGRUPO__|' + g.codigo, {
          accion: 'RENOMBRAR_GRUPO',
          tipo: self.tipologiaClasificacion.tipo,
          grupoCodigo: g.codigo,
          grupoDenominacion: deno
        });
      });
    },
    eliminarGrupo(g) {
      const self = this;
      if (g.obligatorio) { self.$f7.dialog.alert('Los grupos obligatorios no se pueden borrar.'); return; }
      if ((self.caracteristicasEfectivas(g) || []).length) {
        self.$f7.dialog.alert('Vacía el grupo primero (arrastra sus características a otros grupos) y luego bórralo.');
        return;
      }
      var kCrear = '__CREARGRUPO__|' + g.codigo;
      if (self.cambiosCaracteristicas[kCrear]) {
        self.$delete(self.cambiosCaracteristicas, kCrear);
        return;
      }
      self.$f7.dialog.confirm('¿Borrar el grupo «' + (g.denominacion || g.codigo) + '»?', function () {
        self.$set(self.cambiosCaracteristicas, '__ELIMINARGRUPO__|' + g.codigo, {
          accion: 'ELIMINAR_GRUPO',
          tipo: self.tipologiaClasificacion.tipo,
          grupoCodigo: g.codigo,
          grupoObligatorio: false,
          rutaDestino: (self.tipologiaClasificacion.subtipos || []).slice()
        });
      });
    },
    _codigoGrupoDeno(deno) {
      return (deno || '').toString().trim().toUpperCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^A-Z0-9]+/g, '_').replace(/^_+|_+$/g, '') || 'GRUPO';
    },
    // ===================== Administración manual: chips de formato =====================
    cargarChipsFormato() {
      const self = this;
      var codigos = self.codigosFormatosUsados(self.$refs.rform);
      if (!codigos.length) { self.$f7.dialog.alert('Añade primero formatos en "Formatos abstraídos".'); return; }
      self.cargandoChips = true;
      ItemClasificacion.formatoCaracteristicas(codigos).then(function (grupos) {
        self.cargandoChips = false;
        // Guardamos TODAS; el computed formatoChipsGrupos muestra solo las no asignadas (en vivo).
        self.formatoChipsRaw = (grupos || []).map(function (fg) {
          return { codigo: fg.codigo, nombre: fg.nombre, caracteristicas: fg.caracteristicas || [] };
        });
        self.formatoChipsColapsados = {};
        self.todosChipsColapsados = false;
        if (!self.formatoChipsGrupos.length) self.$f7.toast.create({ text: 'Todas las características de los formatos ya están presentes.', closeTimeout: 2500 }).open();
      }).catch(function (err) {
        self.cargandoChips = false;
        self.$f7.dialog.alert(self._msgErrorAgrupar(err), 'Características de los formatos');
      });
    },
    toggleChipFormato(codigo) {
      this.$set(this.formatoChipsColapsados, codigo, !this.formatoChipsColapsados[codigo]);
    },
    toggleTodosChips() {
      var self = this;
      this.todosChipsColapsados = !this.todosChipsColapsados;
      var nuevo = {};
      (this.formatoChipsGrupos || []).forEach(function (fg) { nuevo[fg.codigo] = self.todosChipsColapsados; });
      this.formatoChipsColapsados = nuevo;
    },
    _norm(s) {
      return (s || '').toString().trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[\s_]+/g, '_');
    },
    // Color estable del chip según su grupo de origen (tono vivo distinto por grupo + franja
    // izquierda de color, para identificarlos de un vistazo).
    estiloChipGrupo(grupoCodigo) {
      if (!grupoCodigo) return {};
      var s = grupoCodigo.toString(), h = 0;
      for (var i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) >>> 0; }
      var hue = h % 360;
      return {
        background: 'hsl(' + hue + ', 72%, 90%)',
        borderColor: 'hsl(' + hue + ', 50%, 72%)',
        borderLeft: '4px solid hsl(' + hue + ', 65%, 50%)',
        color: '#2b2f3a'
      };
    },
    // Tooltip del chip: "grupo — etiqueta".
    tituloChip(ch) {
      var et = ch.label || ch.nombre || '';
      return ch.grupo ? (ch.grupo + ' — ' + et) : et;
    },
    // Carga, por característica (nombre normalizado), de qué formatos de la clasificación procede.
    cargarFormatosOrigen(codigos) {
      const self = this;
      var cods = codigos || [];
      if (!cods.length) { self.formatoCarsPorNombre = {}; return; }
      ItemClasificacion.formatoCaracteristicas(cods).then(function (grupos) {
        var map = {};
        (grupos || []).forEach(function (fg) {
          (fg.caracteristicas || []).forEach(function (it) {
            if (!it || !it.nombre) return;
            var k = self._norm(it.nombre);
            if (!map[k]) map[k] = [];
            if (map[k].indexOf(fg.codigo) < 0) map[k].push(fg.codigo);
          });
        });
        self.formatoCarsPorNombre = map;
      }).catch(function () { /* informativo; si falla no pasa nada */ });
    },
    // Formatos de los que procede una característica (casa por nombre o cualquiera de sus alias).
    formatosDeCaracteristica(c) {
      var self = this;
      var out = [];
      var nombres = [c.nombre].concat(c.aliases || []);
      nombres.forEach(function (n) {
        var arr = self.formatoCarsPorNombre[self._norm(n)];
        if (arr) arr.forEach(function (code) { if (out.indexOf(code) < 0) out.push(code); });
      });
      return out;
    },
    // ===================== Administración manual: drag & drop =====================
    // El payload viaja en dataTransfer (lo conserva el navegador durante todo el arrastre),
    // así el drop SIEMPRE lo tiene aunque dragItem se haya limpiado o no se haya propagado.
    // dragItem solo alimenta los resaltes visuales (barra de drop / zonas).
    onDragCarStart(g, c, ev) {
      var payload = { kind: 'car', grupoCodigo: g.codigo, nombre: c.nombre };
      this.dragItem = payload;
      if (ev && ev.dataTransfer) {
        ev.dataTransfer.effectAllowed = 'move';
        try { ev.dataTransfer.setData('text/plain', JSON.stringify(payload)); } catch (e) {}
      }
    },
    onDragChipStart(ch, ev) {
      var payload = { kind: 'chip', nombre: ch.nombre, label: ch.label || '', descripcion: ch.descripcion || '', tipo: ch.tipo || '' };
      this.dragItem = payload;
      if (ev && ev.dataTransfer) {
        ev.dataTransfer.effectAllowed = 'copy';
        try { ev.dataTransfer.setData('text/plain', JSON.stringify(payload)); } catch (e) {}
      }
    },
    onDragEnd() { this.dragItem = null; },
    _dragData(ev) {
      // Fuente de verdad: el dataTransfer. Fallback a dragItem por si el navegador no lo expone.
      try {
        var s = ev && ev.dataTransfer ? ev.dataTransfer.getData('text/plain') : '';
        if (s) {
          var p = JSON.parse(s);
          if (p && p.kind) return p;
        }
      } catch (e) { /* no era JSON */ }
      return this.dragItem || null;
    },
    onDropEnGrupo(g, ev) {
      var d = this._dragData(ev);
      this.dragItem = null;
      if (!d) return;
      if (d.kind === 'chip') {
        // Soltar un chip de formato directamente en un grupo = añadir la característica NUEVA al grupo.
        this.crearCaracteristicaDesdeChip(g, d);
        return;
      }
      if (d.kind !== 'car') return;
      if (d.grupoCodigo === g.codigo) return;
      this.moverCaracteristicaAGrupo(d.grupoCodigo, d.nombre, g);
    },
    crearCaracteristicaDesdeChip(g, chip) {
      const self = this;
      var nombre = (chip.nombre || '').trim();
      if (!nombre) return;
      // Si ya está en la clasificación (como nombre o alias), no la duplicamos.
      if (self.nombresPresentesSet[self._norm(nombre)]) {
        self.$f7.toast.create({ text: '«' + nombre + '» ya está en la clasificación.', closeTimeout: 1800 }).open();
        return;
      }
      var meta = (self.gruposResueltos || []).find(function (x) { return x.codigo === g.codigo; }) || self.metaGrupoPorCodigo(g.codigo);
      var ruta = (self.tipologiaClasificacion.subtipos || []).slice();
      self.$set(self.cambiosCaracteristicas, self.keyCambio(g.codigo, nombre), {
        accion: 'CREAR',
        tipo: self.tipologiaClasificacion.tipo,
        grupoCodigo: g.codigo,
        grupoDenominacion: g.denominacion || (meta && meta.denominacion) || g.codigo,
        grupoOrden: g.orden != null ? g.orden : (meta ? meta.orden : null),
        grupoObligatorio: !!g.obligatorio,
        nombreCaracteristica: nombre,
        rutaOrigen: ruta,
        rutaDestino: ruta,
        manualOverride: true,
        label: chip.label || '',
        descripcion: chip.descripcion || '',
        tipoCaracteristica: chip.tipo || 'TEXT',
        aliases: []
      });
      self.$f7.toast.create({ text: '«' + nombre + '» añadida a ' + (g.denominacion || g.codigo) + '.', closeTimeout: 1800 }).open();
    },
    onDropEnCaracteristica(g, c, ev) {
      var d = this._dragData(ev);
      this.dragItem = null;
      if (!d) return;
      if (d.kind === 'chip') {
        this.anadirAliasA(g, c, d.nombre);
        return;
      }
      if (d.kind === 'car') {
        if (d.grupoCodigo === g.codigo) {
          this.reordenarAnteDe(g, d.nombre, c.nombre);
        } else {
          this.moverCaracteristicaAGrupo(d.grupoCodigo, d.nombre, g, c.nombre);
        }
      }
    },
    anadirAliasA(g, c, aliasNombre) {
      const self = this;
      var alias = (aliasNombre || '').trim();
      if (!alias) return;
      if (alias.toLowerCase() === (c.nombre || '').toLowerCase()) { self.$f7.toast.create({ text: 'Mismo nombre; no se añade.', closeTimeout: 1800 }).open(); return; }
      var actuales = (c.aliases || []).slice();
      if (actuales.some(function (a) { return a && a.toLowerCase() === alias.toLowerCase(); })) {
        self.$f7.toast.create({ text: '«' + alias + '» ya es alias de ' + c.nombre + '.', closeTimeout: 1800 }).open();
        return;
      }
      actuales.push(alias);
      self._registrarEditarAliases(g, c, actuales);
      self.$set(c, 'aliases', actuales);
      // El chip usado desaparece solo: formatoChipsGrupos (computed) recalcula las NO asignadas.
      self.$f7.toast.create({ text: '«' + alias + '» añadido como alias de ' + c.nombre + '.', closeTimeout: 1800 }).open();
    },
    _registrarEditarAliases(g, c, aliases) {
      var k = this.keyCambio(g.codigo, c.nombre);
      var ex = this.cambiosCaracteristicas[k];
      if (ex && ex.accion === 'CREAR') {
        this.$set(this.cambiosCaracteristicas, k, Object.assign({}, ex, { aliases: aliases }));
        return;
      }
      var base = (ex && ex.accion === 'EDITAR') ? ex : {
        accion: 'EDITAR',
        tipo: this.tipologiaClasificacion.tipo,
        grupoCodigo: g.codigo,
        grupoDenominacion: g.denominacion,
        grupoOrden: g.orden,
        grupoObligatorio: !!g.obligatorio,
        nombreCaracteristica: c.nombre,
        rutaOrigen: (c.rutaActual || []).slice(),
        rutaDestino: (c.rutaActual || []).slice(),
        label: null, descripcion: null
      };
      this.$set(this.cambiosCaracteristicas, k, Object.assign({}, base, { aliases: aliases }));
    },
    moverCaracteristicaAGrupo(grupoOrigenCodigo, nombre, grupoDestino, anteDeNombre) {
      const self = this;
      if (self.estaCaracteristicaNueva(grupoOrigenCodigo, nombre)) {
        // Alta pendiente: solo cambiamos su grupo en el cambio CREAR.
        var kc = self.keyCambio(grupoOrigenCodigo, nombre);
        var p = self.cambiosCaracteristicas[kc];
        if (!p) return;
        self.$delete(self.cambiosCaracteristicas, kc);
        self.$set(self.cambiosCaracteristicas, self.keyCambio(grupoDestino.codigo, nombre), Object.assign({}, p, {
          grupoCodigo: grupoDestino.codigo,
          grupoDenominacion: grupoDestino.denominacion,
          grupoOrden: grupoDestino.orden,
          grupoObligatorio: !!grupoDestino.obligatorio
        }));
        return;
      }
      var gOrigen = (self.gruposResueltos || []).find(function (x) { return x.codigo === grupoOrigenCodigo; });
      if (!gOrigen || !gOrigen.caracteristicas) return;
      var idx = gOrigen.caracteristicas.findIndex(function (x) { return x.nombre === nombre; });
      if (idx < 0) return;
      var car = gOrigen.caracteristicas[idx];
      gOrigen.caracteristicas.splice(idx, 1);
      // Grupo destino en los datos del back (si no existe aún, lo creamos como real).
      var gDestRes = (self.gruposResueltos || []).find(function (x) { return x.codigo === grupoDestino.codigo; });
      if (!gDestRes) {
        gDestRes = { codigo: grupoDestino.codigo, denominacion: grupoDestino.denominacion, orden: grupoDestino.orden, obligatorio: !!grupoDestino.obligatorio, caracteristicas: [] };
        self.gruposResueltos.push(gDestRes);
      }
      if (!gDestRes.caracteristicas) self.$set(gDestRes, 'caracteristicas', []);
      // Si el grupo destino YA tiene una característica con ese nombre, no la duplicamos:
      // se consolida (el backend MOVER_GRUPO también deduplica al insertar).
      var yaEnDestino = gDestRes.caracteristicas.some(function (x) { return x.nombre && x.nombre.toLowerCase() === (nombre || '').toLowerCase(); });
      if (!yaEnDestino) {
        var insAt = gDestRes.caracteristicas.length;
        if (anteDeNombre) {
          var ti = gDestRes.caracteristicas.findIndex(function (x) { return x.nombre === anteDeNombre; });
          if (ti >= 0) insAt = ti;
        }
        gDestRes.caracteristicas.splice(insAt, 0, car);
      }
      self.$set(self.cambiosCaracteristicas, '__MOVERGRUPO__|' + grupoOrigenCodigo + '|' + nombre, {
        accion: 'MOVER_GRUPO',
        tipo: self.tipologiaClasificacion.tipo,
        grupoCodigo: grupoOrigenCodigo,
        grupoCodigoDestino: grupoDestino.codigo,
        grupoDenominacion: grupoDestino.denominacion,
        grupoOrden: grupoDestino.orden,
        grupoObligatorio: !!grupoDestino.obligatorio,
        nombreCaracteristica: nombre,
        rutaOrigen: (car.rutaActual || []).slice(),
        rutaDestino: (car.rutaActual || []).slice(),
        subtiposClasif: (self.tipologiaClasificacion.subtipos || []).slice()
      });
      if (anteDeNombre) self.registrarReorden(gDestRes);
    },
    reordenarAnteDe(g, nombreArrastrado, nombreObjetivo) {
      const self = this;
      if (nombreArrastrado === nombreObjetivo) return;
      var gRes = (self.gruposResueltos || []).find(function (x) { return x.codigo === g.codigo; });
      if (!gRes || !gRes.caracteristicas) return;
      var from = gRes.caracteristicas.findIndex(function (x) { return x.nombre === nombreArrastrado; });
      var to = gRes.caracteristicas.findIndex(function (x) { return x.nombre === nombreObjetivo; });
      if (from < 0 || to < 0) return;
      var moved = gRes.caracteristicas.splice(from, 1)[0];
      if (from < to) to--;
      gRes.caracteristicas.splice(to, 0, moved);
      self.registrarReorden(gRes);
    },
    registrarReorden(gRes) {
      const self = this;
      var orden = (gRes.caracteristicas || []).map(function (c, i) {
        return { nombre: c.nombre, ruta: (c.rutaActual || []).slice(), orden: i };
      });
      (gRes.caracteristicas || []).forEach(function (c, i) { self.$set(c, 'orden', i); });
      self.$set(self.cambiosCaracteristicas, '__REORDEN__|' + gRes.codigo, {
        accion: 'REORDENAR',
        tipo: self.tipologiaClasificacion.tipo,
        grupoCodigo: gRes.codigo,
        subtiposClasif: (self.tipologiaClasificacion.subtipos || []).slice(),
        ordenCaracteristicas: orden
      });
    },
    onBorrarCaracteristica(grupo, c) {
      const self = this;
      // Si es un alta pendiente, simplemente la quitamos del mapa.
      if (this.estaCaracteristicaNueva(grupo.codigo, c.nombre)) {
        this.$delete(this.cambiosCaracteristicas, this.keyCambio(grupo.codigo, c.nombre));
        return;
      }
      var rutaClas = this.tipologiaClasificacion.subtipos || [];
      var rutaActual = c.rutaActual || [];
      // Si vive en un nivel superior compartido con tipologías hermanas, NO lo bloqueamos:
      // avisamos de que también se quitará de ellas y dejamos confirmar.
      if (rutaActual.length < rutaClas.length) {
        var nivel = rutaActual.length
          ? this.tipologiaClasificacion.tipo + ' / ' + rutaActual.join(' / ')
          : this.tipologiaClasificacion.tipo;
        this.$f7.dialog.confirm(
          'Esta característica está definida en el nivel superior «' + nivel + '», compartido con otras '
          + 'clasificaciones hermanas. Si la eliminas, también desaparecerá de ellas. ¿Continuar?',
          'Eliminar característica compartida',
          function () { self._registrarEliminar(grupo, c, rutaActual); }
        );
        return;
      }
      this._registrarEliminar(grupo, c, rutaActual);
    },
    _registrarEliminar(grupo, c, rutaActual) {
      var k = this.keyCambio(grupo.codigo, c.nombre);
      this.$set(this.cambiosCaracteristicas, k, {
        accion: 'ELIMINAR',
        tipo: this.tipologiaClasificacion.tipo,
        grupoCodigo: grupo.codigo,
        grupoDenominacion: grupo.denominacion,
        grupoOrden: grupo.orden,
        grupoObligatorio: !!grupo.obligatorio,
        nombreCaracteristica: c.nombre,
        rutaOrigen: (rutaActual || []).slice(),
        rutaDestino: (rutaActual || []).slice(),
        subtiposClasif: (this.tipologiaClasificacion.subtipos || []).slice(),
        manualOverride: !!c.manualOverride
      });
    },
    cancelarBorrarCaracteristica(grupo, c) {
      var k = this.keyCambio(grupo.codigo, c.nombre);
      this.$delete(this.cambiosCaracteristicas, k);
    },
    abrirAltaCaracteristica(grupo) {
      this.nuevaCaractModo = 'alta';
      this.nuevaCaractGrupo = grupo;
      this.nuevaCaractOriginal = null;
      this.nuevaCaract = { nombre: '', label: '', tipo: 'TEXT', descripcion: '', aliasesText: '' };
      this.nuevaCaractPopupOpened = true;
    },
    abrirEdicionCaracteristica(grupo, c) {
      // Si es un alta pendiente, recuperamos los valores del cambio en curso para que
      // editar sobre ese mismo registro y no perder datos. En modo edición real
      // (heredada o ya persistida), partimos de los valores de la característica.
      var k = this.keyCambio(grupo.codigo, c.nombre);
      var pendiente = this.cambiosCaracteristicas[k];
      var fuenteValores;
      if (pendiente && pendiente.accion === 'CREAR') {
        fuenteValores = {
          nombre: pendiente.nombreCaracteristica || c.nombre || '',
          label: pendiente.label || '',
          tipo: pendiente.tipoCaracteristica || 'TEXT',
          descripcion: pendiente.descripcion || '',
          aliasesText: (pendiente.aliases || []).join(', ')
        };
      } else if (pendiente && pendiente.accion === 'EDITAR') {
        fuenteValores = {
          nombre: pendiente.nombreNuevo || pendiente.nombreCaracteristica || c.nombre || '',
          label: pendiente.label != null ? pendiente.label : (c.label || ''),
          tipo: pendiente.tipoCaracteristica || c.tipo || 'TEXT',
          descripcion: pendiente.descripcion != null ? pendiente.descripcion : (c.descripcion || ''),
          aliasesText: (pendiente.aliases || c.aliases || []).join(', ')
        };
      } else {
        fuenteValores = {
          nombre: c.nombre || '',
          label: c.label || '',
          tipo: c.tipo || 'TEXT',
          descripcion: c.descripcion || '',
          aliasesText: (c.aliases || []).join(', ')
        };
      }
      this.nuevaCaractModo = 'edicion';
      this.nuevaCaractGrupo = grupo;
      this.nuevaCaractOriginal = c;
      this.nuevaCaract = fuenteValores;
      this.nuevaCaractPopupOpened = true;
    },
    confirmarPopupCaracteristica() {
      if (this.nuevaCaractModo === 'edicion') {
        this.confirmarEdicionCaracteristica();
      } else {
        this.confirmarAltaCaracteristica();
      }
    },
    confirmarAltaCaracteristica() {
      var nc = this.nuevaCaract;
      var grupo = this.nuevaCaractGrupo;
      if (!grupo) return;
      var nombre = (nc.nombre || '').trim();
      if (!nombre) { this.$f7.dialog.alert('El nombre es obligatorio.'); return; }
      var grupoResuelto = this.gruposResueltos.find(g => g.codigo === grupo.codigo);
      var existeYa = grupoResuelto && (grupoResuelto.caracteristicas || []).some(c => c.nombre && c.nombre.toLowerCase() === nombre.toLowerCase());
      if (existeYa) { this.$f7.dialog.alert('Ya existe una característica con ese nombre en el grupo.'); return; }
      var rutaClas = (this.tipologiaClasificacion.subtipos || []).slice();
      var aliases = (nc.aliasesText || '').split(',').map(s => s.trim()).filter(s => s.length);
      var k = this.keyCambio(grupo.codigo, nombre);
      this.$set(this.cambiosCaracteristicas, k, {
        accion: 'CREAR',
        tipo: this.tipologiaClasificacion.tipo,
        grupoCodigo: grupo.codigo,
        grupoDenominacion: grupo.denominacion,
        grupoOrden: grupo.orden,
        grupoObligatorio: !!grupo.obligatorio,
        nombreCaracteristica: nombre,
        rutaOrigen: rutaClas,
        rutaDestino: rutaClas,
        manualOverride: true,
        label: nc.label || '',
        descripcion: nc.descripcion || '',
        tipoCaracteristica: nc.tipo || 'TEXT',
        aliases: aliases
      });
      this.cerrarPopupCaracteristica();
    },
    confirmarEdicionCaracteristica() {
      var nc = this.nuevaCaract;
      var grupo = this.nuevaCaractGrupo;
      var original = this.nuevaCaractOriginal;
      if (!grupo || !original) return;
      var nombreFinal = (nc.nombre || '').trim();
      if (!nombreFinal) { this.$f7.dialog.alert('El nombre es obligatorio.'); return; }
      var nombreOriginal = original.nombre || '';
      var nombreCambia = nombreFinal.toLowerCase() !== nombreOriginal.toLowerCase();
      var aliases = (nc.aliasesText || '').split(',').map(s => s.trim()).filter(s => s.length);
      // Validación de colisión si se renombra: el nombre nuevo no puede existir ya en
      // el grupo (salvo que sea la propia característica).
      if (nombreCambia) {
        var grupoResuelto = this.gruposResueltos.find(g => g.codigo === grupo.codigo);
        var existeYa = grupoResuelto && (grupoResuelto.caracteristicas || [])
          .some(c => c.nombre && c.nombre.toLowerCase() === nombreFinal.toLowerCase()
                   && c.nombre.toLowerCase() !== nombreOriginal.toLowerCase());
        if (existeYa) { this.$f7.dialog.alert('Ya existe una característica con ese nombre en el grupo.'); return; }
      }
      var keyOriginal = this.keyCambio(grupo.codigo, nombreOriginal);
      var pendiente = this.cambiosCaracteristicas[keyOriginal];
      // Si era un alta pendiente, simplemente actualizamos su payload.
      if (pendiente && pendiente.accion === 'CREAR') {
        // Si el nombre cambia, hay que mover la entrada del mapa al nuevo key.
        this.$delete(this.cambiosCaracteristicas, keyOriginal);
        var rutaClas = (this.tipologiaClasificacion.subtipos || []).slice();
        var keyNueva = this.keyCambio(grupo.codigo, nombreFinal);
        this.$set(this.cambiosCaracteristicas, keyNueva, Object.assign({}, pendiente, {
          nombreCaracteristica: nombreFinal,
          rutaOrigen: pendiente.rutaOrigen || rutaClas,
          rutaDestino: pendiente.rutaDestino || rutaClas,
          label: nc.label || '',
          descripcion: nc.descripcion || '',
          tipoCaracteristica: nc.tipo || 'TEXT',
          aliases: aliases
        }));
      } else {
        // Edición de heredada/persistida. Registramos un cambio EDITAR.
        var rutaOrigen = (original.rutaActual || []).slice();
        var keyEntrada = this.keyCambio(grupo.codigo, nombreOriginal);
        var entrada = {
          accion: 'EDITAR',
          tipo: this.tipologiaClasificacion.tipo,
          grupoCodigo: grupo.codigo,
          grupoDenominacion: grupo.denominacion,
          grupoOrden: grupo.orden,
          grupoObligatorio: !!grupo.obligatorio,
          nombreCaracteristica: nombreOriginal,
          rutaOrigen: rutaOrigen,
          rutaDestino: rutaOrigen,
          label: nc.label || '',
          descripcion: nc.descripcion || '',
          tipoCaracteristica: nc.tipo || 'TEXT',
          aliases: aliases
        };
        if (nombreCambia) entrada.nombreNuevo = nombreFinal;
        this.$set(this.cambiosCaracteristicas, keyEntrada, entrada);
      }
      this.cerrarPopupCaracteristica();
    },
    /**
     * Cierra el popup desmontándolo (v-if) y desactiva el backdrop que F7 deja
     * huérfano al destruir un popup abierto sin pasar por su ciclo de cierre.
     */
    cerrarPopupCaracteristica() {
      this.nuevaCaractPopupOpened = false;
      this.nuevaCaractGrupo = null;
      this.nuevaCaractOriginal = null;
      this.limpiarBackdropsHuerfanos();
    },
    onPopupCaracteristicaClosed() {
      // Cierre por Cancelar / swipe: F7 ya gestionó el backdrop, pero limpiamos igual
      // por si quedó alguno activo de un cierre anterior.
      this.nuevaCaractPopupOpened = false;
      this.limpiarBackdropsHuerfanos();
    },
    limpiarBackdropsHuerfanos() {
      setTimeout(function () {
        document.querySelectorAll('.popup-backdrop.backdrop-in').forEach(function (el) {
          el.classList.remove('backdrop-in');
        });
        // Si ya no queda ningún popup abierto, restaura el scroll: al cerrar un popup montado
        // con v-if no se ejecuta el ciclo de F7 y queda en <html> la clase with-modal-popup,
        // que fuerza overflow:hidden en .page-content y mata el scroll de la página.
        if (!document.querySelector('.popup.modal-in')) {
          document.documentElement.classList.remove(
            'with-modal-popup', 'with-modal-popup-push', 'with-modal-popup-push-closing');
        }
      }, 50);
    },
    /**
     * Nivel sugerido para la plantilla: la profundidad de la característica más
     * profunda que usa. P. ej. AE-{rae} con rae en AE/[ASCENSOR] → nivel 1.
     */
    nivelSugeridoPlantilla(texto) {
      var nivel = 0;
      var re = /\{([^}]+)\}/g;
      var m;
      while ((m = re.exec(texto || '')) !== null) {
        var token = (m[1] || '').trim();
        if (!token || token.toUpperCase() === 'TIPO') continue;
        for (var gi = 0; gi < this.gruposResueltos.length; gi++) {
          // Lista efectiva: incluye las altas pendientes (aún sin guardar), que viven
          // al nivel de esta clasificación y deben empujar el nivel sugerido. La
          // profundidad efectiva también refleja los movimientos de chips pendientes.
          var grupo = this.gruposResueltos[gi];
          var cars = this.caracteristicasEfectivas(grupo) || [];
          for (var ci = 0; ci < cars.length; ci++) {
            var c = cars[ci];
            if (c.nombre && c.nombre.toLowerCase() === token.toLowerCase()) {
              var p = this.profundidadEfectiva(grupo.codigo, c);
              if (p > nivel) nivel = p;
            }
          }
        }
      }
      return nivel;
    },
    chipsPlantilla() {
      var tipo = this.tipologiaClasificacion.tipo || '';
      var ruta = this.tipologiaClasificacion.subtipos || [];
      var nivel = this.nivelPlantillaEfectivo;
      var chips = [{
        label: tipo,
        activo: true,
        titulo: 'Plantilla a nivel de tipo: aplica a todo ' + tipo
      }];
      for (var i = 0; i < ruta.length; i++) {
        chips.push({
          label: ruta[i],
          activo: nivel >= (i + 1),
          titulo: 'Nivel: ' + tipo + ' / ' + ruta.slice(0, i + 1).join(' / ')
        });
      }
      return chips;
    },
    onChipPlantillaClick(indiceChip) {
      var nivelActual = this.nivelPlantillaEfectivo;
      var nuevaProf;
      if (indiceChip === 0) {
        nuevaProf = 0;
      } else if (indiceChip <= nivelActual) {
        nuevaProf = indiceChip - 1;
      } else {
        nuevaProf = indiceChip;
      }
      if (nuevaProf === nivelActual) return;
      this.registrarCambioPlantilla(this.plantillaIdEfectiva, nuevaProf);
    },
    onPlantillaIdChange(valor) {
      var v = (valor || '').trim();
      var original = this.tipologiaClasificacion.plantillaIdItem || '';
      // Sin cambio real respecto a lo resuelto → quitar pendiente si lo había.
      if (v === original) {
        this.$delete(this.cambiosCaracteristicas, '__PLANTILLA_ID__');
        return;
      }
      // Nivel sugerido: el de la característica más profunda usada en la plantilla.
      // Después se puede ajustar con los chips.
      this.registrarCambioPlantilla(v, this.nivelSugeridoPlantilla(v));
    },
    tokenUsadoEnPlantilla(nombre) {
      if (!nombre) return false;
      var plantilla = this.plantillaIdEfectiva || '';
      return plantilla.toLowerCase().indexOf('{' + nombre.toLowerCase() + '}') >= 0;
    },
    /**
     * Toggle de un token {nombre} en la plantilla: si no está, lo inserta en la
     * posición del cursor con separador '-' automático; si ya está, lo quita junto con
     * su separador adyacente. 'TIPO' es el token especial {TIPO}.
     */
    toggleTokenPlantilla(nombre) {
      if (this.tokenUsadoEnPlantilla(nombre)) {
        this.quitarTokenPlantilla(nombre);
      } else {
        this.insertarTokenPlantilla(nombre);
      }
    },
    _hexToRgba(hex, a) {
      var h = String(hex || '').replace('#', '');
      var r = parseInt(h.substring(0, 2), 16);
      var g = parseInt(h.substring(2, 4), 16);
      var b = parseInt(h.substring(4, 6), 16);
      return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
    },
    /** Estilo del chip de un grupo: tinte suave si no está en uso, sólido si está. */
    estiloChipGrupo(idx, usado) {
      var hex = this.tokenPaleta[idx % this.tokenPaleta.length];
      if (usado) {
        return { background: hex, color: '#fff', borderColor: hex };
      }
      return { background: this._hexToRgba(hex, 0.12), color: hex, borderColor: this._hexToRgba(hex, 0.5) };
    },
    insertarTokenPlantilla(nombre) {
      var token = '{' + nombre + '}';
      var el = this.$refs.plantillaInput;
      var actual = el ? el.value : this.plantillaIdEfectiva;
      var pos = el && typeof el.selectionStart === 'number' ? el.selectionStart : actual.length;
      var antes = actual.slice(0, pos);
      var despues = actual.slice(pos);
      // Separador: si lo anterior no acaba en '-', '{' o vacío, metemos '-'.
      var sep = antes && !/[-{]$/.test(antes) ? '-' : '';
      var nuevo = antes + sep + token + despues;
      this.registrarCambioPlantilla(nuevo.trim(), this.nivelSugeridoPlantilla(nuevo));
      // Recolocar cursor tras el token insertado (cuando Vue re-renderice el value).
      var nuevaPos = (antes + sep + token).length;
      this.$nextTick(function () {
        if (el) {
          el.focus();
          try { el.setSelectionRange(nuevaPos, nuevaPos); } catch (e) {}
        }
      });
    },
    quitarTokenPlantilla(nombre) {
      var plantilla = this.plantillaIdEfectiva || '';
      // Quita {token} y su separador '-' adyacente (el anterior; si iba al principio,
      // el posterior). Escapamos el nombre por si trae caracteres especiales de regex.
      var esc = nombre.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var re = new RegExp('-?\\{' + esc + '\\}', 'i');
      var nuevo = plantilla.replace(re, '');
      // Si quedó un '-' colgando al principio (el token iba primero), lo quitamos.
      nuevo = nuevo.replace(/^-+/, '').replace(/-+$/, '').replace(/--+/g, '-').trim();
      this.registrarCambioPlantilla(nuevo, this.nivelSugeridoPlantilla(nuevo));
    },
    registrarCambioPlantilla(texto, nivel) {
      var subtiposClas = this.tipologiaClasificacion.subtipos || [];
      // La plantilla se guarda SIEMPRE en el nivel propio (el más profundo) de la clasificación,
      // que es justo de donde el resolver la lee (la más específica). Así la edición se respeta
      // siempre. (El parámetro `nivel` ya no decide el nivel de guardado.)
      var rutaDestino = subtiposClas.slice();
      var original = this.tipologiaClasificacion.plantillaIdItem || '';
      if ((texto || '') === original) {
        this.$delete(this.cambiosCaracteristicas, '__PLANTILLA_ID__');
        return;
      }
      this.$set(this.cambiosCaracteristicas, '__PLANTILLA_ID__', {
        accion: 'PLANTILLA_ID',
        tipo: this.tipologiaClasificacion.tipo,
        grupoCodigo: 'IDENTIFICACION',
        grupoDenominacion: 'Identificación',
        grupoOrden: 1,
        grupoObligatorio: true,
        nombreCaracteristica: '__PLANTILLA_ID__',
        rutaOrigen: rutaDestino.slice(),
        rutaDestino: rutaDestino,
        subtiposClasif: subtiposClas.slice(),
        plantillaIdItem: texto
      });
    },
    cancelarCambiosCaracteristicas() {
      this.cambiosCaracteristicas = {};
    },
    // --- Sugerir características desde los formatos abstraídos (clusters IA) ---
    codigosFormatosUsados(rform) {
      var arr = (rform && rform.formData && rform.formData.formatosUsados) || [];
      return arr.map(function (e) { return (e && typeof e === 'object') ? e.codigo : e; })
        .filter(function (c) { return c; });
    },
    sugerirCaracteristicasDesdeFormatos(rform) {
      const self = this;
      var codigos = self.codigosFormatosUsados(rform);
      if (!codigos.length) {
        self.$f7.dialog.alert('Selecciona primero algún formato en "Formatos abstraídos".');
        return;
      }
      if (!self.tipologiaClasificacion.tipo) {
        self.$f7.dialog.alert('Guarda primero la clasificación (tipo y subtipos) para poder añadir características a su maestro.');
        return;
      }
      // Si una tanda ya calculó esta propuesta por detrás, se usa y no se vuelve a pagar la
      // llamada a la IA, que son varios minutos. Solo vale si sigue correspondiendo a los
      // formatos de AHORA: si se vincularon o quitaron formatos después, lo propuesto es de otro
      // conjunto y aplicarlo metería en el catálogo características que ya no le tocan.
      var idClasif = rform && rform.formData ? rform.formData.id : null;
      if (!idClasif) {
        self._lanzarAgrupacion(rform, codigos);
        return;
      }
      ItemClasificacion.sugerenciaCaracteristicas(idClasif).then(function (sug) {
        if (sug && sug.resultado && !sug.caducada) {
          self._abrirClustersGuardados(sug);
          return;
        }
        if (sug && sug.resultado && sug.caducada) {
          self.$f7.dialog.confirm(
            'Hay una propuesta calculada antes, pero los formatos de esta clasificación han'
            + ' cambiado desde entonces, así que no corresponde a lo que hay ahora.'
            + ' ¿Recalcularla? (tarda unos minutos)',
            'Propuesta caducada',
            function () { self._lanzarAgrupacion(rform, codigos); }
          );
          return;
        }
        self._lanzarAgrupacion(rform, codigos);
      }).catch(function () {
        // Que no se pueda consultar lo guardado no debe impedir agrupar: se lanza como siempre.
        self._lanzarAgrupacion(rform, codigos);
      });
    },

    /** Pinta una propuesta ya calculada por la tanda, sin llamar a la IA. */
    _abrirClustersGuardados(sug) {
      const self = this;
      self.clustersFormatos = [];
      self.clustersPlantillaSugerida = '';
      self.clustersPlantillaExplicacion = '';
      self.clustersNarracion = null;
      self.clustersCargando = false;
      self.clustersCancelando = false;
      self.clustersPopupOpened = true;
      self._sugerenciaGuardadaId = sug.idClasificacion;
      self._construirClustersDesde(sug.resultado || {});
      if (!self.clustersFormatos.length) {
        self.cerrarClustersPopup();
        self.$f7.dialog.alert('La propuesta calculada no traía características que agrupar.', 'Sugerir características');
      }
    },

    _lanzarAgrupacion(rform, codigos) {
      const self = this;
      self._sugerenciaGuardadaId = null;
      // Abre el popup en modo "cargando" y deja que la narración SSE cuente el avance,
      // para que no parezca colgado (la agrupación tarda un poco).
      self.clustersFormatos = [];
      self.clustersPlantillaSugerida = '';
      self.clustersPlantillaExplicacion = '';
      self.clustersNarracion = { latin: 'Starting', texto: 'Preparando la agrupación…', hechos: 0, total: 0 };
      self.clustersCargando = true;
      self.clustersCancelando = false;
      self.clustersPopupOpened = true;
      if (!self._agruparHandler) self._agruparHandler = self._onAgruparEvent.bind(self);
      // Lanzar PRIMERO (fija el estado del run actual en el backend) y suscribirse DESPUÉS,
      // para que el reenvío del último evento corresponda a este run y no a uno anterior.
      ItemClasificacion.agruparCaracteristicas(codigos, self.tipologiaClasificacion.tipo, self.tipologiaClasificacion.subtipos, rform.formData.naturaleza).then(function (res) {
        // Solo corre una agrupación a la vez. Si ya hay otra, esta ventana no tiene nada que
        // esperar: quedarse escuchando el stream —que es único— le traeria los clusters de la
        // otra clasificación. Se cierra en vez de suscribirse.
        if (res && res.lanzado === false && res.enCurso) {
          self.cerrarClustersPopup();
          self.$f7.dialog.alert('Ya hay una agrupación en curso en otra clasificación. Espera a que'
            + ' termine y vuelve a lanzarla aquí.', 'Sugerir características');
          return;
        }
        RevisionFormatosEvents.subscribe(self._agruparHandler, self.$f7);
      }).catch(function (err) {
        self.cerrarClustersPopup();
        self.$f7.dialog.alert(self._msgErrorAgrupar(err), 'Sugerir características');
      });
    },
    _onAgruparEvent(payload) {
      const self = this;
      if (!payload || typeof payload !== 'object' || payload.accion !== 'agrupar') return;
      // El evento dice de que clasificacion es. Si no es la que hay abierta, no es nuestro: el
      // stream es unico y aplicar clusters ajenos meteria en esta clasificacion el catalogo de
      // otra. (Los eventos viejos sin `tipo` se aceptan, para no romper si el back no esta al dia.)
      if (payload.tipo && !self._esDeEstaClasificacion(payload)) return;
      if (payload.estado === 'progreso') {
        self.clustersNarracion = { latin: payload.latin, texto: payload.texto, hechos: payload.hechos, total: payload.total };
      } else if (payload.estado === 'fin') {
        RevisionFormatosEvents.unsubscribe(self._agruparHandler);
        self.clustersNarracion = null;
        self.clustersCargando = false;
        self._construirClustersDesde(payload.resultado || {});
        if (!self.clustersFormatos.length) {
          self.cerrarClustersPopup();
          self.$f7.dialog.alert('La IA no encontró características que agrupar.', 'Sugerir características');
        }
      } else if (payload.estado === 'cancelado') {
        self.cerrarClustersPopup();
        self.$f7.toast.create({ text: 'Fusión de características cancelada.', closeTimeout: 2500 }).open();
      } else if (payload.estado === 'error') {
        self.cerrarClustersPopup();
        self.$f7.dialog.alert(payload.texto || 'Error agrupando características', 'Sugerir características');
      }
    },
    cancelarClusters() {
      const self = this;
      if (self.clustersCancelando) return;
      self.clustersCancelando = true;
      // Avisamos al back para que detenga la fusión y aborte la llamada a la IA (libera tokens).
      // El cierre del popup llega por el evento SSE 'cancelado'.
      ItemClasificacion.cancelarAgrupar().catch(function () {
        // Aunque falle el aviso, cerramos: el usuario quiere parar (cierre limpio + backdrop).
        self.cerrarClustersPopup();
      });
    },
    _construirClustersDesde(dto) {
      const self = this;
      var grupos = (dto && dto.grupos) || [];
      self.clustersGruposExtra = (dto && dto.gruposExtra) || [];
      self.clustersPlantillaSugerida = (dto && dto.plantillaSugerida) || '';
      self.clustersPlantillaExplicacion = (dto && dto.plantillaExplicacion) || '';
      self.clustersAplicarPlantilla = !!self.clustersPlantillaSugerida;
      self.clustersFormatos = grupos.map(function (g, i) {
        var variantes = (g.variantes || []).map(function (v) { return v.nombre; }).filter(function (n) { return n; });
        // Opciones de nombre canónico: el sugerido + las variantes (dedup).
        var opciones = [];
        [g.sugerido].concat(variantes).forEach(function (n) {
          if (n && opciones.indexOf(n) < 0) opciones.push(n);
        });
        return {
          sugerido: g.sugerido,
          label: g.label || '',
          tipo: g.tipo || 'TEXT',
          variantes: g.variantes || [],
          opciones: opciones,
          // Marca del backend: la IA no devolvió esta característica en ningún cluster y se
          // rescató para que no se perdiera. Sin arrastrarla aquí, el aviso no se puede pintar.
          noAgrupadaPorIa: !!g.noAgrupadaPorIa,
          _idx: i,
          _incluir: true,
          _canonico: g.sugerido || (opciones[0] || ''),
          // Grupo sugerido por el backend (IDENTIFICACION / EMPLAZAMIENTO / OTROS).
          _grupo: g.grupoSugerido || 'OTROS',
          // Rol en los datos del titular (NOMBRE / NIF) que propone la IA para las de
          // TITULARIDAD: dice cual de ellas es el titular del item, que no siempre es el
          // cliente que contrata la inspeccion.
          _rolTitular: g.rolTitular || null
        };
      });
    },
    /** ¿El evento de agrupación corresponde a la clasificación abierta? */
    _esDeEstaClasificacion(payload) {
      var norm = function (x) {
        return String(x || '').normalize ? String(x || '').normalize('NFD').replace(new RegExp('[̀-ͯ]', 'g'), '').toUpperCase().replace(/[^A-Z0-9]/g, '') : String(x || '').toUpperCase();
      };
      if (norm(payload.tipo) !== norm(this.tipologiaClasificacion.tipo)) return false;
      var a = (payload.subtipos || []).map(norm).join('>');
      var b = (this.tipologiaClasificacion.subtipos || []).map(norm).join('>');
      return a === b;
    },
    _msgErrorAgrupar(err) {
      return typeof err === 'string' ? err : (err && (err.message || (err.error && err.error.message))) || 'Error agrupando características';
    },
    cerrarClustersPopup() {
      // Punto ÚNICO de cierre del popup de clusters (lo llaman @popup:closed y los cierres
      // programáticos: cancelar, error, aplicar). Al desmontar con v-if un popup abierto, F7
      // deja el backdrop huérfano → siempre limpiamos con limpiarBackdropsHuerfanos().
      if (this._agruparHandler) RevisionFormatosEvents.unsubscribe(this._agruparHandler);
      this.clustersPopupOpened = false;
      this.clustersCargando = false;
      this.clustersCancelando = false;
      this.clustersNarracion = null;
      this.limpiarBackdropsHuerfanos();
    },
    categoriaCluster(cl) {
      // Categoría a efectos de filtro, según el grupo asignado (editable por el usuario).
      if (cl._grupo === 'IDENTIFICACION') return 'IDENTIFICACION';
      if (cl._grupo === 'EMPLAZAMIENTO') return 'EMPLAZAMIENTO';
      return 'OTROS';
    },
    contarClustersPorCategoria(cat) {
      var self = this;
      return this.clustersFormatos.filter(function (cl) { return self.categoriaCluster(cl) === cat; }).length;
    },
    /**
     * El tipo que propone la IA, saneado contra TipoCaracteristicaEnum. Lo devuelve como texto
     * libre ("tipo de dato si se infiere: TEXT, NUMBER, DATE…") y a veces sale en inglés: un
     * "TABLE" tumbaba el guardado entero con un error de deserializacion del enum. Ante la duda,
     * TEXT, que es lo que se venía usando por defecto.
     */
    /** Nombre comparable: sin tildes, sin separadores y en mayúsculas. */
    normalizarNombreCaract(n) {
      var x = String(n || '');
      x = x.normalize ? x.normalize('NFD').replace(new RegExp('[̀-ͯ]', 'g'), '') : x;
      return x.toUpperCase().replace(/[^A-Z0-9]/g, '');
    },
    tipoCaracteristicaValido(tipo) {
      var validos = ['TEXT', 'TEXTAREA', 'NUMBER', 'DATE', 'CHECK', 'MULTICHECK', 'RADIO',
        'SIMPLELIST', 'MULTILIST', 'TABLA', 'TABLA_DINAMICA', 'TABLA_PERSONALIZADA', 'NOTA',
        'FIRMA', 'AUTOCALCULADO', 'TRANSFORMADOR', 'COMPROBACION', 'GROUP', 'NO_ENCONTRADO'];
      var equivalencias = {
        TABLE: 'TABLA', DYNAMIC_TABLE: 'TABLA_DINAMICA', CUSTOM_TABLE: 'TABLA_PERSONALIZADA',
        STRING: 'TEXT', TEXTO: 'TEXT', LONGTEXT: 'TEXTAREA', NUMERIC: 'NUMBER', NUMERO: 'NUMBER',
        INTEGER: 'NUMBER', DECIMAL: 'NUMBER', FECHA: 'DATE', BOOLEAN: 'CHECK', CHECKBOX: 'CHECK',
        LIST: 'SIMPLELIST', SELECT: 'SIMPLELIST', MULTISELECT: 'MULTILIST', NOTE: 'NOTA',
        SIGNATURE: 'FIRMA'
      };
      var t = String(tipo || '').trim().toUpperCase();
      if (validos.indexOf(t) >= 0) return t;
      if (equivalencias[t]) return equivalencias[t];
      return 'TEXT';
    },
    aliasesDeCluster(cl) {
      // Todas las variantes (+ el sugerido) menos el nombre canónico elegido.
      var todos = [];
      (cl.variantes || []).forEach(function (v) { if (v.nombre && todos.indexOf(v.nombre) < 0) todos.push(v.nombre); });
      if (cl.sugerido && todos.indexOf(cl.sugerido) < 0) todos.push(cl.sugerido);
      return todos.filter(function (n) { return n && n.toLowerCase() !== (cl._canonico || '').toLowerCase(); });
    },
    aplicarClustersSeleccionados() {
      const self = this;
      var subtiposClas = (self.tipologiaClasificacion.subtipos || []).slice();
      var añadidas = 0, omitidas = 0, enriquecidas = 0;
      self.clustersFormatos.forEach(function (cl) {
        if (!cl._incluir) return;
        var nombre = (cl._canonico || '').trim();
        if (!nombre) { omitidas++; return; }
        var grupoCodigo = cl._grupo || 'IDENTIFICACION';
        var grupoResuelto = self.gruposResueltos.find(function (g) { return g.codigo === grupoCodigo; });
        // ¿Existe ya esa característica? Se busca en TODO el catálogo resuelto, no solo en el
        // grupo que sugiere la IA: si vive en otro grupo y solo mirásemos el sugerido, se crearía
        // duplicada. Y si existe, manda dónde está: el grupo se decide una vez, no en cada
        // revisión de formatos.
        var grupoDeLaExistente = null;
        var yaExistente = null;
        var clave = self.normalizarNombreCaract(nombre);
        (self.gruposResueltos || []).some(function (g) {
          // Comparación normalizada (sin tildes ni separadores): el formato escribe
          // "datos_de_inspección" y el catálogo "datos_de_inspeccion". Comparando en crudo se
          // creaba una segunda característica en vez de añadir el nombre como alias, y el
          // catálogo acababa con la misma cosa dos veces.
          var hit = (g.caracteristicas || []).find(function (c) {
            if (!c.nombre) return false;
            if (self.normalizarNombreCaract(c.nombre) === clave) return true;
            return (c.aliases || []).some(function (a) { return self.normalizarNombreCaract(a) === clave; });
          });
          if (hit) { yaExistente = hit; grupoDeLaExistente = g; return true; }
          return false;
        });
        if (yaExistente) {
          // Existía ya, pero el formato nuevo puede llamarla de otra forma. Antes se descartaba
          // el cluster entero y con él esos nombres, que son justo lo que hace que el sync
          // reconozca la característica en expedientes de ese formato (y lo que permite juzgar
          // un discriminante escrito sobre ella). Ahora se añaden como alias.
          var nuevos = self.aliasesDeCluster(cl).filter(function (a) {
            if (!a || a.toLowerCase() === nombre.toLowerCase()) return false;
            return !(yaExistente.aliases || []).some(function (x) { return x && x.toLowerCase() === a.toLowerCase(); });
          });
          if (!nuevos.length) { omitidas++; return; }
          var aliasesFinales = (yaExistente.aliases || []).slice().concat(nuevos);
          self._registrarEditarAliases(grupoDeLaExistente, yaExistente, aliasesFinales);
          self.$set(yaExistente, 'aliases', aliasesFinales);
          enriquecidas++;
          return;
        }
        var meta = grupoResuelto || self.metaGrupoPorCodigo(grupoCodigo);
        var k = self.keyCambio(grupoCodigo, nombre);
        self.$set(self.cambiosCaracteristicas, k, {
          accion: 'CREAR',
          tipo: self.tipologiaClasificacion.tipo,
          grupoCodigo: grupoCodigo,
          grupoDenominacion: meta ? meta.denominacion : grupoCodigo,
          grupoOrden: meta ? meta.orden : null,
          grupoObligatorio: meta ? !!meta.obligatorio : false,
          nombreCaracteristica: nombre,
          rutaOrigen: subtiposClas,
          rutaDestino: subtiposClas,
          manualOverride: true,
          label: cl.label || '',
          descripcion: '',
          tipoCaracteristica: self.tipoCaracteristicaValido(cl.tipo),
          aliases: self.aliasesDeCluster(cl),
          rolTitular: cl._rolTitular || null
        });
        añadidas++;
      });
      var msgPlantilla = '';
      if (self.clustersAplicarPlantilla && self.clustersPlantillaSugerida) {
        self.registrarCambioPlantilla(self.clustersPlantillaSugerida, self.nivelSugeridoPlantilla(self.clustersPlantillaSugerida));
        msgPlantilla = ' Plantilla de ID propuesta aplicada (editable).';
      }
      self.cerrarClustersPopup();
      var msg = añadidas + ' característica(s) añadida(s) como pendientes.'
        + (enriquecidas ? ' ' + enriquecidas + ' ya existían y se les han añadido alias.' : '')
        + (omitidas ? ' ' + omitidas + ' omitida(s) (sin nombre o sin nada nuevo que aportar).' : '');
      self.$f7.toast.create({ text: msg + msgPlantilla + ' Pulsa «Guardar» para confirmar.', closeTimeout: 3500 }).open();
      // Si esto venía de una propuesta calculada en tanda, se descarta: ya está aplicada, y
      // dejarla ahí haría que la próxima vez se ofreciera de nuevo con características que ahora
      // ya están en el catálogo. Best-effort: si falla, lo peor es volver a verla.
      if (self._sugerenciaGuardadaId) {
        var id = self._sugerenciaGuardadaId;
        self._sugerenciaGuardadaId = null;
        ItemClasificacion.descartarSugerencia(id).catch(function () {});
      }
    },
    metaGrupoPorCodigo(codigo) {
      // Metadatos por defecto para los grupos obligatorios cuando aún no están resueltos.
      var defaults = {
        IDENTIFICACION: { denominacion: 'Identificación', orden: 1, obligatorio: true },
        EMPLAZAMIENTO: { denominacion: 'Emplazamiento', orden: 2, obligatorio: true },
        TITULARIDAD: { denominacion: 'Titularidad', orden: 3, obligatorio: false }
      };
      if (defaults[codigo]) return defaults[codigo];
      // Grupos temáticos extra propuestos por la IA: usamos su denominación legible.
      var extra = (this.clustersGruposExtra || []).find(function (g) { return g && g.codigo === codigo; });
      if (extra) return { denominacion: extra.denominacion || codigo, orden: null, obligatorio: false };
      return { denominacion: codigo, orden: null, obligatorio: false };
    },
    /**
     * Guarda TODO desde el botón «Guardar» de la cabecera: primero aplica los cambios
     * pendientes de características (maestro de tipologías) y luego guarda la clasificación.
     */
    guardarTodo() {
      const self = this;
      if (!self.hayCambiosCaracteristicas) {
        self.$refs.rform.saveItem();
        return;
      }
      // #663 · La espera de la sesión: si la sesión cambia en vuelo o se sale de la pantalla, no
      // queda el modal puesto esperando a un `then` que ya no toca.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      self.guardarCambiosCaracteristicas(true).then(function () {
        espera.cerrar();
        self.$refs.rform.saveItem();
      }).catch(function () {
        espera.cerrar();
        // El error ya se mostró en guardarCambiosCaracteristicas; no guardamos la clasificación.
      });
    },
    /**
     * Aplica los cambios pendientes de características. Devuelve una promesa.
     * @param {boolean} chained Si true (llamado desde guardarTodo), no gestiona preloader ni
     *   muestra el toast propio (lo gestiona quien encadena); igualmente recarga los grupos.
     */
    guardarCambiosCaracteristicas(chained) {
      const self = this;
      const cambios = Object.values(self.cambiosCaracteristicas);
      if (!cambios.length) return Promise.resolve();
      const url = ItemClasificacion.server_movilidad + ItemClasificacion.prefix
        + 'itemtipologiacaracteristicas/aplicar-cambios';
      var params = {
        url: url, method: 'POST', crossDomain: true, dataType: 'json',
        contentType: 'application/json',
        // OJO: F7 hace JSON.stringify(data) él mismo cuando contentType es
        // application/json — pasarle el array ya stringificado lo doble-serializa
        // y el back recibe un string en vez de un array (400 MismatchedInput).
        data: cambios
      };
      try {
        var session = JSON.parse(localStorage.getItem('session') || 'null');
        var token = session && (session.token || session.access_token);
        if (token) params.headers = { Authorization: 'Bearer ' + token };
      } catch (e) {}
      const espera = preloaderDeLaSesion(self);
      if (!chained) espera.mostrar();
      return ItemClasificacion.request.promise(params).then(function () {
        if (!chained) espera.cerrar();
        self.cambiosCaracteristicas = {};
        self.cargarGruposResueltos();
        if (!chained) self.$f7.toast.create({ text: 'Cambios aplicados', closeTimeout: 1500 }).open();
      }).catch(function (err) {
        if (!chained) espera.cerrar();
        // El mensaje útil viene en el body de la respuesta (ResponseDto.error.message);
        // err.message de F7 es el statusText, casi siempre vacío.
        var msg = null;
        try {
          var body = err && err.xhr && err.xhr.responseText ? JSON.parse(err.xhr.responseText) : null;
          msg = body && body.error && (body.error.message || body.error.code);
        } catch (e) { /* responseText no era JSON */ }
        if (!msg) {
          msg = typeof err === 'string' ? err : (err.message || ('HTTP ' + (err.status || '?')));
        }
        self.$f7.dialog.alert(msg, 'Error guardando características');
        return Promise.reject(err);
      });
    },
    cargarCodigos() {
      const self = this;
      return ItemTipoClasificacion.getList({ page: 1, limit: 1000 }, true)
        .then(function (res) {
          var items = (res && (res.list || res.content || res.data || res)) || [];
          if (!Array.isArray(items) && items.content) items = items.content;
          var arr = (items || []).filter(function (it) { return it && it.codigo; }).map(function (it) {
            return {
              codigo: it.codigo,
              denominacion: it.denominacion || '',
              naturalezaDefault: it.naturalezaDefault || '',
              reglamentoDefault: it.reglamentoDefault || '',
              itcDefault: it.itcDefault || '',
              colorBadge: it.colorBadge || ''
            };
          });
          arr.sort(function (a, b) { return a.codigo.localeCompare(b.codigo); });
          self.codigosDisponibles = arr;
        })
        .catch(function () { self.codigosDisponibles = []; });
    },
    onCodigoSelectChange(rform) {
      if (!rform || !rform.formData) return;
      if (rform.formData.codigo === '__NUEVO__') {
        // No dejamos el marcador seleccionado; abrimos el alta de tipo.
        this.$set(rform.formData, 'codigo', '');
        this.nuevoTipoPopupOpened = true;
        return;
      }
      // Auto-rellenar denominacion/naturaleza/reglamento/itc desde el maestro.
      this.aplicarTipoSeleccionado(rform, rform.formData.codigo);
    },
    aplicarTipoSeleccionado(rform, codigo) {
      var tipo = this.codigosDisponibles.find(function (x) { return x.codigo === codigo; });
      if (!tipo) return;
      if (tipo.denominacion)        this.$set(rform.formData, 'denominacion', tipo.denominacion);
      if (tipo.naturalezaDefault)   this.$set(rform.formData, 'naturaleza',   tipo.naturalezaDefault);
      if (tipo.reglamentoDefault)   this.$set(rform.formData, 'reglamento',   tipo.reglamentoDefault);
      if (tipo.itcDefault)          this.$set(rform.formData, 'itc',          tipo.itcDefault);
    },
    beforeSaveNuevoTipo(data, resolve, reject) {
      if (!data.codigo || !data.codigo.trim()) { this.$f7.dialog.alert('El código es obligatorio.'); return reject(); }
      if (!data.denominacion || !data.denominacion.trim()) { this.$f7.dialog.alert('La denominación es obligatoria.'); return reject(); }
      data.codigo = data.codigo.trim().toUpperCase();
      resolve(data);
    },
    onNuevoTipoCreado(tipo) {
      const self = this;
      // rForm.saveItem deja el preloader visible (no navegamos tras crear), así que lo ocultamos.
      self.$f7.preloader.hide();
      if (!tipo || !tipo.codigo) {
        self.cerrarPopupNuevoTipo();
        return;
      }
      // Recargamos la lista de tipos desde el back para que codigosDisponibles incluya el
      // recién creado de forma autoritativa (con todos sus campos), y esperamos al render
      // (nextTick) para que el <option> exista en el DOM antes de seleccionarlo.
      self.cargarCodigos()
        .then(function () {
          return self.$nextTick();
        })
        .then(function () {
          var rform = self.$refs.rform;
          if (rform && rform.formData) {
            self.$set(rform.formData, 'codigo', tipo.codigo);
            self.aplicarTipoSeleccionado(rform, tipo.codigo);
          }
        })
        .finally(function () {
          self.cerrarPopupNuevoTipo();
        });
    },
    cerrarPopupNuevoTipo() {
      const self = this;
      try {
        self.$f7.popup.close('.popup-nuevo-tipo');
      } catch (e) {
        self.nuevoTipoPopupOpened = false;
      }
    },
    addSubtipo(rform) {
      if (!rform.formData.subtipos) this.$set(rform.formData, 'subtipos', []);
      rform.formData.subtipos.push('');
    },
    removeSubtipo(rform, i) {
      rform.formData.subtipos.splice(i, 1);
    },
    addGrupo(rform) {
      if (!rform.formData.grupos) this.$set(rform.formData, 'grupos', []);
      const ordenes = rform.formData.grupos.map(g => g.orden || 0);
      const next = (ordenes.length ? Math.max(...ordenes) : 0) + 1;
      rform.formData.grupos.push({
        codigo: '', denominacion: '', orden: next, obligatorio: false, caracteristicas: []
      });
    },
    removeGrupo(rform, i) {
      const g = rform.formData.grupos[i];
      if (g && g.obligatorio) return;
      rform.formData.grupos.splice(i, 1);
    },
    addCaracteristica(rform, gi) {
      const g = rform.formData.grupos[gi];
      if (!g.caracteristicas) this.$set(g, 'caracteristicas', []);
      g.caracteristicas.push({ nombre: '', label: '', tipo: 'TEXT', obligatorio: false });
    },
    removeCaracteristica(rform, gi, ci) {
      rform.formData.grupos[gi].caracteristicas.splice(ci, 1);
    },
    beforeSave(data, resolve, reject) {
      if (!data.codigo) { this.$f7.dialog.alert('El código (tipo) es obligatorio.'); return reject(); }
      if (!data.naturaleza) { this.$f7.dialog.alert('La naturaleza es obligatoria.'); return reject(); }
      data.codigo = (data.codigo + '').trim().toUpperCase();
      // Limpieza: quitar subtipos vacíos
      if (Array.isArray(data.subtipos)) {
        data.subtipos = data.subtipos.map(s => (s || '').trim()).filter(s => s.length > 0);
      }
      // Reconstruir mini-materias {id, codigo, nombre, codigoExpediente} a partir
      // del array de códigos que mantiene r-autocomplete-m2m en formData.materias.
      if (Array.isArray(data.materias)) {
        var ac = this.$refs.materiasAutocomplete;
        var sourceItems = (ac && ac.items) || (ac && ac.autocomplete && ac.autocomplete.items) || [];
        var byCodigo = {};
        sourceItems.forEach(function (it) { if (it && it.codigo != null) byCodigo[it.codigo] = it; });
        data.materias = data.materias.map(function (entry) {
          var codigo = (entry && typeof entry === 'object') ? entry.codigo : entry;
          var src = byCodigo[codigo] || (typeof entry === 'object' ? entry : {});
          return {
            id: src.id || null,
            codigo: codigo,
            nombre: src.nombre || '',
            codigoExpediente: src.codigoExpediente || null
          };
        }).filter(function (m) { return m.codigo; });
      }
      // Reconstruir formatosUsados {id, codigo} a partir del array que mantiene el
      // r-autocomplete-m2m de formatos (puede traer códigos sueltos u objetos).
      if (Array.isArray(data.formatosUsados)) {
        var acF = this.$refs.formatosAutocomplete;
        var srcF = (acF && acF.items) || (acF && acF.autocomplete && acF.autocomplete.items) || [];
        var byCodigoF = {};
        srcF.forEach(function (it) { if (it && it.codigo != null) byCodigoF[it.codigo] = it; });
        data.formatosUsados = data.formatosUsados.map(function (entry) {
          var codigo = (entry && typeof entry === 'object') ? entry.codigo : entry;
          var src = byCodigoF[codigo] || (typeof entry === 'object' ? entry : {});
          return { id: src.id || null, codigo: codigo };
        }).filter(function (f) { return f.codigo; });
      }
      // Convertir aliasesText (string CSV editable en UI) → aliases (List<String>) y
      // eliminar aliasesText del payload. Es la única transformación necesaria porque
      // el back solo conoce `aliases`.
      if (Array.isArray(data.grupos)) {
        data.grupos.forEach(function (g) {
          if (!Array.isArray(g.caracteristicas)) return;
          g.caracteristicas.forEach(function (c) {
            if (typeof c.aliasesText === 'string') {
              c.aliases = c.aliasesText.split(',')
                .map(function (s) { return s.trim(); })
                .filter(function (s) { return s.length > 0; });
              delete c.aliasesText;
            }
          });
        });
      }
      // El tipo siempre existe aquí: o se eligió del maestro o se creó vía "Nuevo tipo…".
      resolve(data);
    },
    onSave(res) {
      // Si era un alta, navegamos a la vista del item recién creado.
      if (!this.id && res && res.id) {
        this.$f7router.navigate(
          '/itemclasificacion/view/' + encodeURIComponent(res.id) + '/',
          { reloadCurrent: true }
        );
        return;
      }
      // Edición de item existente: nos quedamos aquí, en modo lectura.
      this.readonly = true;
      // La propuesta de la IA ya está persistida: deja de estar "pendiente".
      if (this.discPropuestaPendiente) {
        this.discPropuestaPendiente = false;
        this.ofrecerReclasificar();
      }
    },
    deleteItem() {
      const self = this;
      self.$f7.dialog.confirm('¿Eliminar esta clasificación?', () => {
        ItemClasificacion.delete({ itemId: self.id }).then(() => {
          self.$f7router.back();
        }).catch((err) => {
          self.$f7.dialog.alert(typeof err === 'string' ? err : (err.message || 'Error al eliminar.'));
        });
      });
    }
  }
};
</script>

<style scoped>
.full-width-input {
  width: 100%;
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
}
.observaciones-input ::v-deep textarea {
  width: 100%;
  box-sizing: border-box;
  min-height: 96px;
}
.indicaciones-identificacion-hint {
  font-size: 12px;
  color: #666;
  margin: 0 0 8px;
}
.naturaleza-input ::v-deep select {
  background-color: var(--naturaleza-bg, transparent);
}
.grupo-card {
  border: 1px solid #d0d4dc;
  border-radius: 6px;
  padding: 8px 10px;
  margin: 6px 0;
  background: #fafbfd;
}
/* ---- Administración manual ---- */
.admin-manual-barra {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  padding: 4px 0 8px;
  font-size: 13px;
}
.formato-chips-barra {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex-wrap: wrap;
  padding: 6px 8px;
  margin-bottom: 8px;
  background: #f3f7fb;
  border: 1px dashed #c2d6ea;
  border-radius: 6px;
}
.formato-chips-grupo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 6px;
  background: #fff;
  border: 1px solid #dbe6f1;
  border-radius: 6px;
}
.formato-chips-cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-basis: 100%;
}
.formato-chips-grupo-tit {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 320px;
  cursor: pointer;
  user-select: none;
}
.formato-chips-grupo-tit .f7-icons { font-size: 14px; color: #8a94a6; }
.formato-chips-grupo-tit code { font-size: 11px; }
.formato-chips-count {
  font-size: 10px;
  font-weight: 700;
  color: #5a6b86;
  background: #dde6f1;
  border-radius: 8px;
  padding: 0 6px;
}
.formato-chips-grupo-chips { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px; }
.formato-chip {
  display: inline-block;
  padding: 2px 8px;
  font-size: 11px;
  font-family: ui-monospace, Consolas, monospace;
  background: #e7f0fa;
  border: 1px solid #bcd6ef;
  border-radius: 10px;
  cursor: grab;
  user-select: none;
}
.formato-chip:active { cursor: grabbing; }
.grupo-dropzone { outline: 2px dashed #9c6ade; outline-offset: -3px; }
.cambios-pendientes-aviso {
  font-size: 12px;
  font-weight: 600;
  color: #d9822b;
}
/* Barra de bloques grandes para soltar en otro grupo mientras se arrastra.
   position:fixed (overlay): así su aparición NO remaqueta el contenido en flujo y no aborta
   el arrastre nativo de Chrome (que se cancela si la fila arrastrada se reposiciona). */
.drop-grupos-barra {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 13500;
  display: flex;
  align-items: stretch;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px 12px;
  background: #f3eefc;
  border-top: 2px solid #d7c4f0;
  box-shadow: 0 -4px 14px rgba(0, 0, 0, 0.12);
}
.drop-grupos-hint {
  align-self: center;
  font-size: 12px;
  font-weight: 600;
  color: #5b3a99;
}
.drop-grupo-bloque {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 130px;
  min-height: 46px;
  padding: 8px 16px;
  flex: 1 1 130px;
  justify-content: center;
  text-align: center;
  font-weight: 600;
  font-size: 13px;
  color: #4a148c;
  background: #fff;
  border: 2px dashed #b794e6;
  border-radius: 8px;
  cursor: copy;
  transition: background 0.12s, border-color 0.12s, transform 0.08s;
}
.drop-grupo-bloque:hover {
  background: #ede0fb;
  border-color: #7e3ff2;
  transform: scale(1.03);
}
.drop-grupo-bloque .f7-icons { font-size: 18px; color: #7e3ff2; }
.grupo-acciones { margin-left: auto; display: inline-flex; gap: 4px; }
.drag-handle-cell { width: 22px; text-align: center; }
.drag-grip {
  cursor: grab;
  color: #9aa3b2;
  font-size: 14px;
  line-height: 1;
  user-select: none;
}
.drag-grip:active { cursor: grabbing; }
.caracteristica-droptarget { outline: 1px dashed #e0a900; outline-offset: -2px; }
.caract-formatos-origen {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  flex-wrap: wrap;
  margin-left: 6px;
  vertical-align: middle;
}
.caract-formatos-origen .f7-icons { font-size: 12px; color: #8a94a6; }
.formato-origen-chip {
  display: inline-block;
  padding: 0 6px;
  font-size: 10px;
  font-family: ui-monospace, Consolas, monospace;
  color: #5a6b86;
  background: #eef2f7;
  border: 1px solid #dbe3ee;
  border-radius: 8px;
}
.grupo-header {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}
.grupo-header .grupo-denom {
  flex: 2;
  min-width: 200px;
}
.grupo-header .grupo-codigo {
  flex: 1;
  min-width: 120px;
}
.grupo-header .grupo-orden {
  width: 80px;
}
.grupo-obligatorio-badge {
  background: #e0e0e0;
  color: #555;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.grupo-body {
  margin-left: 4px;
}
.grupo-body-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}
.caracteristica-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px dashed #e8eaee;
}
.caracteristica-row > .item-input-wrap,
.caracteristica-row ::v-deep > div {
  flex: 1;
}
.caracteristicas-resueltas {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.caracteristicas-resueltas th {
  text-align: left;
  padding: 4px 6px;
  background: #eef0f4;
  border-bottom: 1px solid #d0d4dc;
  font-weight: 600;
}
.caracteristicas-resueltas td {
  padding: 3px 6px;
  border-bottom: 1px dashed #e8eaee;
  vertical-align: top;
}
.caracteristicas-resueltas td code {
  font-family: monospace;
  font-size: 11px;
}
.caracteristica-modificada {
  background-color: #fff8e1;
}
.caracteristica-eliminada td {
  text-decoration: line-through;
  color: #b71c1c;
  background-color: #ffebee;
}
.caracteristica-nueva td {
  background-color: #e8f5e9;
  font-style: italic;
}
.grupo-body-footer {
  padding: 4px 0 0 4px;
  border-top: 1px dashed #e8eaee;
  margin-top: 4px;
}
.rename-pending {
  margin-left: 4px;
  font-size: 10px;
  color: #ef6c00;
  font-style: italic;
}
.caract-label {
  font-size: 12px;
  font-weight: 600;
  color: #455a64;
  margin: 6px 0 2px 2px;
}
/* Barra "Sugerir características desde formatos" + popup de clusters */
.formatos-ia-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #d4e3f2;
}
.clusters-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 14px;
  border-bottom: 1px solid #e0e4ea;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
}
.clusters-filtro {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 14px;
  border-bottom: 1px solid #eef1f5;
}
.clusters-narracion {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 16px 24px;
  text-align: center;
}
.clusters-lista { padding: 10px 12px; }
.cluster-card {
  border: 1px solid #d0d4dc;
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 8px;
  background: #fafbfd;
}
.cluster-off { opacity: 0.5; }
.cluster-head {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.cluster-check input { width: 18px; height: 18px; }
.cluster-aliases {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  margin-top: 6px;
}
.cluster-origen {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 6px;
}
.cluster-origen-item code {
  font-family: monospace;
  font-size: 10px;
  background: #eef0f4;
  padding: 1px 5px;
  border-radius: 4px;
}
.rp-input {
  padding: 4px 8px;
  border: 1px solid #c5b6e0;
  border-radius: 5px;
  font-size: 13px;
  background: #fff;
}
.alias-badge {
  background: #e3f2fd;
  color: #1565c0;
  padding: 1px 6px;
  border-radius: 8px;
  font-size: 10px;
}
.plantilla-id-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 6px 8px;
  margin-bottom: 8px;
  background: #f3f7fb;
  border: 1px solid #d4e3f2;
  border-radius: 6px;
}
.plantilla-id-input {
  flex: 1 1 280px;
  min-width: 220px;
  padding: 5px 10px;
  border: 1px solid #b6cee6;
  border-radius: 6px;
  font-family: ui-monospace, "Cascadia Code", Consolas, monospace;
  font-size: 12px;
  background: #fff;
}
.plantilla-id-valor {
  font-family: ui-monospace, "Cascadia Code", Consolas, monospace;
  font-size: 12px;
  background: #eef3f8;
  padding: 3px 8px;
  border-radius: 4px;
}
.plantilla-chips {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
}
.plantilla-builder {
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 5px;
  padding-top: 6px;
  border-top: 1px dashed #d4e3f2;
}
.token-grupo-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.token-grupo-label {
  flex: 0 0 150px;
  max-width: 150px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .3px;
  color: #7a8aa0;
  text-align: right;
  padding-right: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.token-chip {
  font-family: ui-monospace, "Cascadia Code", Consolas, monospace;
  font-size: 11px;
  background: #e3f2fd;
  color: #1565c0;
  border: 1px solid #90caf9;
  border-radius: 4px;
  padding: 1px 7px;
  cursor: pointer;
  user-select: none;
}
.token-chip:hover {
  background: #bbdefb;
}
.token-chip-tipo {
  background: #ede7f6;
  color: #4527a0;
  border-color: #b39ddb;
}
.token-chip-tipo:hover {
  background: #d1c4e9;
}
.token-chip.token-chip-usado {
  background: #1565c0;
  color: #fff;
  border-color: #0d47a1;
  font-weight: 600;
}
.token-chip.token-chip-usado:hover {
  background: #0d47a1;
}
.token-chip-tipo.token-chip-usado {
  background: #4527a0;
  color: #fff;
  border-color: #311b92;
}
.token-chip-tipo.token-chip-usado:hover {
  background: #311b92;
}
.token-chip-emplazamiento {
  background: #e0f2f1;
  color: #00695c;
  border-color: #80cbc4;
}
.token-chip-emplazamiento:hover {
  background: #b2dfdb;
}
.token-chip-emplazamiento.token-chip-usado {
  background: #00695c;
  color: #fff;
  border-color: #004d40;
}
.token-chip-emplazamiento.token-chip-usado:hover {
  background: #004d40;
}
.chip-tipologia {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  margin: 1px 2px;
  border-radius: 12px;
  font-size: 11px;
  background: #e8eaee;
  color: #888;
  border: 1px solid transparent;
  user-select: none;
}
.chip-tipologia.chip-activo {
  background: #c8e6c9;
  color: #1b5e20;
  border-color: #81c784;
  font-weight: 600;
}
.chip-tipologia.chip-clickable {
  cursor: pointer;
}
.chip-tipologia.chip-clickable:hover {
  border-color: #1976d2;
}
.chip-tipologia.chip-raiz {
  border-style: solid;
}
.chip-manual-badge {
  display: inline-block;
  margin-left: 4px;
  background: #d32f2f;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
}
.chip-manual-badge:hover {
  background: #b71c1c;
}

/* --- Discriminantes de subtipo --- */
.disc-cond {
  padding: 6px 0;
  border-top: 1px dashed #eef1f5;
}
.disc-cond-linea {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.disc-si { font-size: 12px; color: #666; }
.disc-carac-wrap { display: inline-flex; flex-direction: column; gap: 1px; }
.disc-nombre-tec { font-size: 10px; color: #8a8f98; padding-left: 2px; }
.disc-opc-count { color: #b36b00; margin-left: 5px; }
.disc-select {
  border: 1px solid #d5dbe3;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 12px;
  background: #fff;
  min-width: 130px;
  max-width: 240px;
}
.disc-input {
  border: 1px solid #d5dbe3;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 12px;
  width: 90px;
}
.disc-input-libre { width: 190px; }
.disc-valores {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  margin: 5px 0 0 20px;
}
.disc-valores-lbl { font-size: 11px; color: #888; }
.chip-valor {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: #e8f0fe;
  color: #1a4b8c;
  border: 1px solid #c5d9f7;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 11px;
  cursor: pointer;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chip-valor .chip-x { font-size: 13px; color: #7089b0; flex: none; }
.disc-falta { font-size: 11px; color: #c0392b; font-weight: 600; }
.disc-just {
  font-size: 10px;
  font-style: italic;
  color: #999;
  margin: 3px 0 0 20px;
}
.disc-pendiente {
  background: #fff8e1;
  border: 1px solid #ffe08a;
  border-radius: 5px;
  padding: 5px 9px;
  font-size: 12px;
  color: #7a5c00;
  margin-bottom: 6px;
}
.disc-reclas-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  background: #eef6ff;
  border: 1px solid #cfe2fb;
  border-radius: 5px;
  padding: 5px 9px;
  font-size: 12px;
  color: #1a4b8c;
  margin-bottom: 6px;
}
.disc-reclas-cont { font-weight: 700; font-variant-numeric: tabular-nums; }
.disc-empates-zona { margin-top: 10px; border-top: 1px solid #eef1f5; padding-top: 6px; }
.disc-empate {
  border: 1px solid #f3d6d6;
  background: #fff8f8;
  border-radius: 4px;
  padding: 4px 8px;
  margin: 4px 0;
}

/* Explicaciones de la IA: parrafos largos legibles y con scroll dentro del dialogo.
   Sin scoped: el dialogo lo monta F7 fuera del componente. */
</style>

<style>
.disc-dialog-texto {
  text-align: left;
  font-size: 13px;
  line-height: 1.5;
  max-height: 55vh;
  overflow-y: auto;
  white-space: normal;
}
.dialog .dialog-text:has(.disc-dialog-texto) { text-align: left; }
</style>
